import L from "leaflet";
import { file } from "paths.macro";
import { NavLeafCanvas } from "../base/nav-leaf-canvas";
import { eventBus } from "@/main";
import store from "@/store";
import * as utils from "@/utils/utils";
import { getS63CKTInfo } from "@/utils/utils";
import * as colorControl from "./colors-control";
import { PythonArray } from "@/helpers/pythonArray";
import { useMomentaryStore } from "@/stores/momentary";

import "../extensions/easy-button";
import "../extensions/easy-button.css";

import "leaflet-draw/dist/leaflet.draw-src.css";
import "leaflet-draw/dist/leaflet.draw.css";

import "../extensions/leaflet-search/leaflet-search.min.js";
import "../extensions/leaflet-search/leaflet-search.min.css";

import { CURRENT_PRODUCT, NAVICOM } from "@/utils/build-config";
import "../styles/route-styles.css";
import "../styles/controls.css";
import router from "@/router";

let orderTextOnChart;
let shipTextOnChart;
let isShipSelected = false;

let goodCells = [];
let goodCellsId = [];

let cellByRouteId = "";

let upButton = null;

let cellButton = null;

let downButton = null;

import lineIntersect from "@turf/line-intersect";
import polygonToLine from "@turf/polygon-to-line";

import * as turf from "@turf/turf";
import intersect from "@turf/intersect";
import iconImg from "@/assets/ship_1tx_green.png";
import dayjs from "dayjs";
import { drawCharts } from "@/my-leaf/routes/components/route-graphs";
// import {lastIndexOf} from "lodash";

class PaneControl {
  constructor(map) {
    this.map = map;
    this.Panes = {};
  }

  get panes_ids_list() {
    return Object.keys(this.Panes);
  }

  do(zind) {
    // console.log(zind)
    if (!this.panes_ids_list.find((x) => x == zind)) {
      this.Panes[zind] = this.map.createPane(zind);
      this.Panes[zind].style.zIndex = zind;
      // console.log('pane created ' + zind)
    }
    // else console.log('pane already exist' + zind);
  }

  clearPanes() {
    delete this.map._panes.custom;
    delete this.map._paneRenderers.custom;
    this.Panes = {};
  }
}

function ChartsType() {
  this.bigCells = {
    lg: L.layerGroup(),
  };
  this.midCells = {
    lg: L.layerGroup(),
  };
  this.lilCells = {
    lg: L.layerGroup(),
  };
}

export class ChartsLeaf extends NavLeafCanvas {
  customControl = null;

  customControl1 = null;

  wpArray;

  wpIndex;

  logbookGroup = null;

  constructor() {
    super();
    this.availablePeriods = ["4", "1", "0"];
    // Переменная для хранения текущего временного прямоугольника подсветки
    this.currentHighlightRectangle = null;
    // Флаг для предотвращения очистки подсветки во время программного зумирования
    this.isProgrammaticZoom = false;
    // Флаг для пропуска dispatchSelectedCells при toggle disabled
    this.skipDispatchSelectedCells = false;
  }

  legsGroup = null;

  wpGroup = null;

  wpMarker = L.divIcon({
    className: "",
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    html: "<div style='font-size: 20px'>&#9022;</div>",
  });

  showAnotherRoute() {
    let points = this.routesStore.getShipWaypoints;

    console.log(
      "ChartsLeaf: отрисовка маршрута с",
      points?.length || 0,
      "точками"
    );
    console.log("ChartsLeaf: данные маршрута:", points);
    console.log("ChartsLeaf: состояние routesStore:", {
      hasResponse: !!this.routesStore.getShipResponse,
      calculatedRouteLegs:
        this.routesStore.getShipResponse?.calculatedRouteLegs?.length || 0,
      routeLength: this.routesStore.getShipResponse?.routeLength || 0,
    });

    // Проверяем, что есть точки маршрута и группа инициализирована
    if (!points || points.length === 0) {
      console.log("ChartsLeaf: нет точек маршрута для отображения");
      return;
    }

    if (!this.legsGroup) {
      console.warn(
        "ChartsLeaf: legsGroup не инициализирована, пропускаем отрисовку маршрута"
      );
      return;
    }

    console.log("ChartsLeaf: отрисовываем маршрут с", points.length, "точками");

    // let newMarker = new L.marker(points[0], {id: 1, title: 'WP1', icon: this.wpMarker}).addTo(this.wpGroup);

    // let newMarker1 = new L.marker([60.0,30.0], {id: 1, title: 'WP1', icon: this.wpMarker}).addTo(this.map);
    // newMarker1.bindTooltip('WP1', {permanent: true}).openTooltip();
    //
    // let newMarker2 = new L.marker([50.0,30.0], {id: 2, title: 'WP2', icon: this.wpMarker}).addTo(this.map);
    // newMarker2.bindTooltip('WP2', {permanent: true}).openTooltip();
    //
    // let points1 = [newMarker1.getLatLng(), newMarker2.getLatLng()]
    // L.polyline(points1, {color: 'red'}).addTo(this.map);

    // points.forEach(wp => {
    //     let newMarker = new L.marker([wp.lat, wp.lon], {title: 'WP', icon: this.wpMarker}).addTo(this.wpGroup);
    //     // newMarker.bindTooltip('WP', {permanent: true}).openTooltip();
    // })

    L.polyline(points, {
      color: "blue",
      weight: 2 /*, dashArray: '5, 5', dashOffset: '0'*/,
    }).addTo(this.legsGroup);

    // let newMarker1 = new L.marker([60.0,30.0], {id: 2, title: 'WP2', icon: this.wpMarker}).addTo(this.ChartsLayers.overview);
    // L.polyline(points, {color: 'red'}).addTo(this.legsGroup);
  }

  init(el, drawRoute = false, selectCharts = false) {
    console.log("ChartsLeaf: инициализация карты начата");
    console.log(
      "ChartsLeaf: параметры init - drawRoute:",
      drawRoute,
      "selectCharts:",
      selectCharts
    );
    console.log(
      "ChartsLeaf: ПРОВЕРКА ДВОЙНОЙ ИНИЦИАЛИЗАЦИИ - map уже существует:",
      !!this.map
    );
    console.log(
      "ChartsLeaf: стек вызова init:",
      new Error().stack.split("\n").slice(0, 5).join("\n")
    );

    // Защита от двойной инициализации
    if (this.map) {
      console.warn(
        "ChartsLeaf: ПРЕДУПРЕЖДЕНИЕ - карта уже инициализирована, пропускаем повторную инициализацию"
      );
      console.warn(
        "ChartsLeaf: существующая карта имеет ID контейнера:",
        this.map.getContainer().id
      );
      console.warn("ChartsLeaf: новый элемент имеет ID:", el?.id);
      return;
    }

    this.autoscale_bands = true;
    this.chartsSelectable = selectCharts;
    console.log(
      "ChartsLeaf: chartsSelectable установлен в:",
      this.chartsSelectable
    );
    super.init(el);
    this.drawRoute = drawRoute;
    this.catalogueNotHistory = true;
    this.osmLayer = L.tileLayer("https://api.probki.net/map/{z}/{x}/{y}", {
      minZoom: 2,
      maxZoom: 20,
    });
    this.map.setMinZoom(2);

    // alert(L.Projection.Mercator.project([58.514164292193364,5.592041015625]))
    //
    //
    // console.log("sssss ", L.Projection.Mercator.project(L.latLng(59.87926917467212,4.932861328125001)))
    // let x = [L.Projection.Mercator.project([58.514164292193364,5.592041015625]),([58.25218341893894,6.19903564453125])]
    // // let bounds = this.$store.state.routes.bounds
    // // let y= lineString([[59.87926917467212, 78.53132125001],[0.39069033049765,4.888916015625001]], {pane: 'line1'});
    // let x1 = [L.Projection.Mercator.project([58.514164292193364,5.592041015625]),L.Projection.Mercator.project([58.514164292193364,5.592041015625])([58.25218341893894,6.19903564453125])]
    // let y= lineString(x1, {pane: 'line1'});
    // // let route = lineString(x)
    // // console.log(route, 'ru')
    // L.geoJSON(y).addTo(this.map);

    // let poly = polygon([[[10, -30], [145, -30], [145, -20], [10, -20], [10, -30]]]);
    // let poly1 = polygon([[[10, -30], [145, -30], [145, -20], [10, -20], [10, -30]]]);
    //
    // let line1 = polygonToLine(poly);
    // var line2 = lineString([[11, -34], [126, -28], [184, -24]], {name: 'line 1'});
    // var line3 = lineString([[11, -10], [126, 12], [184, 24]], {name: 'line 2'});
    // var line4 = lineString([[87, 79], [87, 48]], {name: 'line 3'});

    // let route = lineString([[4.932861328125001, 59.87926917467212],[4.888916015625001, 59.39069033049765]], {pane: 'line1'});
    //  L.geoJSON(route).addTo(this.map);

    // let intersect1 = lineIntersect(line1, line2);
    // let intersect2 = lineIntersect(line1, line3);
    //
    //
    // L.geoJSON(line1).addTo(this.map);
    // // L.geoJSON(line2).addTo(this.map);
    // // L.geoJSON(line3).addTo(this.map);
    // // L.geoJSON(line4).addTo(this.map);
    //
    // console.log("a--1 ", intersect1)
    // // alert(intersect1.features.length > 0)
    // console.log("a--2 ", intersect2)
    // // alert(intersect2.features.length > 0)

    this.logbookGroup = L.layerGroup();
    this.map.addLayer(this.logbookGroup);

    this.legsGroup = L.layerGroup();
    this.map.addLayer(this.legsGroup);
    this.legsGroup.bringToFront;

    this.wpGroup = L.layerGroup();
    this.map.addLayer(this.wpGroup);

    // Добавляем группу для маршрутов (для совместимости с функционалом ChartsByRouteLeaf)
    this.routeGroup = L.layerGroup();
    this.map.addLayer(this.routeGroup);

    // document.getElementsByClassName( 'leaflet-control-attribution' )[0].style.display = 'none';

    this.multiTiles = false;

    // let control = L.control.centerCross({show: true, position: "topleft", toggleTitle: 'Toggle crosshair'});
    // this.map.addControl(control);

    this.map.createPane("overview");
    this.map.getPane("overview").style.zIndex = 650;
    this.map.createPane("general");
    this.map.getPane("general").style.zIndex = 660;
    this.map.createPane("coastal");
    this.map.getPane("coastal").style.zIndex = 670;
    this.map.createPane("approach");
    this.map.getPane("approach").style.zIndex = 680;
    this.map.createPane("harbour");
    this.map.getPane("harbour").style.zIndex = 690;
    this.map.createPane("berthing");
    this.map.getPane("berthing").style.zIndex = 700;
    // this.map.createPane('s102')
    // this.map.getPane('s102').style.zIndex = 700;
    this.map.createPane("active");
    this.map.getPane("active").style.zIndex = 710;
    this.activePane = L.layerGroup({}, { pane: "active" }).addTo(this.map);

    this.scope2digit = {
      overview: 1,
      general: 2,
      coastal: 3,
      approach: 4,
      harbour: 5,
      berthing: 6,
    };

    this.ChartsData = {};
    this.ChartsLayers = {
      overview: L.layerGroup({}, { pane: "overview" }),
      general: L.layerGroup({}, { pane: "general" }),
      coastal: L.layerGroup({}, { pane: "coastal" }),
      approach: L.layerGroup({}, { pane: "approach" }),
      harbour: L.layerGroup({}, { pane: "harbour" }),
      berthing: L.layerGroup({}, { pane: "berthing" }),
      unavailable: L.layerGroup(),
      // s102: L.layerGroup({}, {pane: 's102'}),
    };

    this.overlayMaps = {
      Overview: this.ChartsLayers.overview,
      General: this.ChartsLayers.general,
      Coastal: this.ChartsLayers.coastal,
      Approach: this.ChartsLayers.approach,
      Harbour: this.ChartsLayers.harbour,
      Berthing: this.ChartsLayers.berthing,
      // "S102": this.ChartsLayers.s102,
      // "<i>Purchased</i>": this.ChartsLayers.unavailable,
    };

    // this.overlayMapsNavicom =  {
    //         "Navicom" : this.ChartsLayers.general,
    // }

    this.layersControl = L.control.layers({}, this.overlayMaps);
    // var markerLayer = L.layerGroup().addTo(this.map)
    // let marker = L.marker([51.5, -0.09]).addTo(markerLayer);
    // marker.options.title = 'abc'

    // let searchControl = new L.Control.Search({
    //     layer: markerLayer,
    //     moveToLocation: function (latlng, title, map) {
    //         let zoom = map.getBoundsZoom(latlng.layer.getBounds());
    //         map.setView(latlng, zoom); // access the zoom
    //     }
    // })
    //
    // this.map.addControl( searchControl );

    // new L.Control.EasyButton({
    //     states: [{
    //         icon:      'bi bi-search',               // and define its properties
    //         title:     'Search',      // like its title
    //         onClick: (btn) => {       // and its callback
    //             eventBus.$emit("search-maps")
    //         }
    //     }]
    // }).addTo(this.map)

    // L.Map.include({
    //     _initControlPos: function () {
    //         var corners = this._controlCorners = {},
    //             l = 'leaflet-',
    //             container = this._controlContainer =
    //                 L.DomUtil.create('div', l + 'control-container', this._container);
    //
    //         function createCorner(vSide, hSide) {
    //             var className = l + vSide + ' ' + l + hSide;
    //
    //             corners[vSide + hSide] = L.DomUtil.create('div', className, container);
    //         }
    //
    //         createCorner('top', 'left');
    //         createCorner('top', 'right');
    //         createCorner('bottom', 'left');
    //         createCorner('bottom', 'right');
    //
    //         createCorner('top', 'center');
    //         createCorner('middle', 'center');
    //         createCorner('middle', 'left');
    //         createCorner('middle', 'right');
    //         createCorner('bottom', 'center');
    //     }
    // });

    // eventBus.$on('disable-cell', (id) => {
    //     disabledCells.push(id)
    //     console.log(disabledCells)
    // })

    eventBus.$on("enable-cell", (id) => {});

    eventBus.$on("set-new-ship-text-on-chart", (shipName) => {
      // shipTextOnChart.updateContent("<span class='chart-text'>&nbsp;Ship: " + shipName + "&nbsp;</span>")
      isShipSelected = true;
    });

    // L.Control.textbox1 = L.Control.extend({
    //     onAdd: function(map) {
    //         let text = L.DomUtil.create('div');
    //         text.id = "chart_text_order";
    //         text.innerHTML = "<span class='chart-text'>&nbsp;New order&nbsp;</span>"
    //         return text;
    //     },
    //     onRemove: function(map) {
    //         // Nothing to do here
    //     },
    //     updateContent: function(text) {
    //         this.getContainer().innerHTML = text;
    //     }
    // });
    // L.control.textbox1 = function(opts) { return new L.Control.textbox1(opts);}
    // orderTextOnChart = L.control.textbox1({ position: 'topright' }).addTo(this.map);

    // L.Control.textbox2 = L.Control.extend({
    //     onAdd: function(map) {
    //         let text = L.DomUtil.create('div');
    //         text.onclick = () => {
    //             console.log("click on select")
    //             eventBus.$emit("select-ship-from-chart")
    //         }
    //         text.id = "chart_text_ship";
    //         text.innerHTML = ""
    //         // text.innerHTML = "<span class='chart-warning-text'>&nbsp;Click to select a ship&nbsp;</span>"
    //         return text;
    //     },
    //     onRemove: function(map) {
    //         // Nothing to do here
    //     },
    //     updateContent: function(text) {
    //         this.getContainer().innerHTML = text;
    //     }
    // });
    // L.control.textbox2 = function(opts) { return new L.Control.textbox2(opts);}
    // shipTextOnChart = L.control.textbox2({ position: 'topright' }).addTo(this.map);

    // eventBus.$on('set-new-order-text-on-chart', (payload) => {
    //     orderTextOnChart.updateContent("<span class='chart-text'>&nbsp;Order №" + payload.order  +" (" + payload.order_date + ")&nbsp;</span>")
    // })

    eventBus.$on("clear-order-text-on-chart", () => {
      // orderTextOnChart.updateContent("<span class='chart-text'>&nbsp;New order&nbsp;</span>")
      // shipTextOnChart.updateContent("<span class='chart-warning-text'>&nbsp;Click to select a ship&nbsp;</span>")
      isShipSelected = false;
    });

    eventBus.$on("show-from-search", (payload) => {
      this.map.setView([payload.lat, payload.lon], 8);
    });

    // Создаем и сохраняем ссылки на кнопки для последующего удаления
    // Проверяем, что кнопки еще не созданы, чтобы избежать дублирования
    // if (!this.searchButton) {
    //   this.searchButton = new L.Control.EasyButton({
    //     position: 'bottomleft',
    //     states: [
    //       {
    //         icon: 'bi bi-search',
    //         title: 'Search',
    //         onClick: btn => {
    //           eventBus.$emit('search-on-map')
    //         },
    //       },
    //     ],
    //   }).addTo(this.map)
    // }

    // if (!this.graphButton) {
    //   this.graphButton = new L.Control.EasyButton({
    //     position: 'topleft',
    //     states: [
    //       {
    //         icon: 'bi bi-bar-chart-steps',
    //         title: 'Show graph',
    //         onClick: btn => {
    //           drawCharts.call(this, 'chart')
    //           // eventBus.$emit('show-graph-on-map')
    //         },
    //       },
    //     ],
    //   }).addTo(this.map)
    // }

    // eventBus.$on('set-non-primar-layer-control', () => {
    //     alert(2)
    //     this.layersControl.remove();
    //     this.layersControl = L.control.layers({}, this.overlayMaps1)
    // })
    //
    // eventBus.$on('remove-primar-controls', () => {
    //     //TODO NAVICOM
    //     // this.map.removeControl(this.customControl)
    //
    //     // remove customControl
    // })

    this.clearCellslayer();

    this.ChartsLayers.overview.addTo(this.map);
    // this.ChartsLayers.general.addTo(this.map);
    // this.ChartsLayers.approach.addTo(this.map);

    let customControl = L.Control.extend({
      options: {
        position: "topright",
      },

      onAdd: (map) => {
        let container = L.DomUtil.create("input");
        container.button_state = true;
        container.type = "button";
        container.title = "Toggle bands by map scale ";
        container.value = "Auto-Band ✓";
        container.className = "button-14-small";

        container.onclick = () => {
          container.button_state = !container.button_state;
          this.autoscale_bands = container.button_state;
          container.value = container.button_state
            ? "Auto-Band ✓"
            : "Auto-Band ☐";
        };

        return container;
      },
    });

    this.map.addControl(new customControl());

    // downButton = new L.Control.EasyButton({
    //     position: 'bottomright',
    //     states: [{
    //         stateName: 'on',        // name the state
    //         icon:      'bi bi-caret-left-fill',               // and define its properties
    //         title:     'move to prev cell',      // like its title
    //         onClick: (btn) => {       // and its callback
    //             // eventBus.$emit('move-prev' )
    //             console.log(this.wpIndex, 'wpi')
    //             // this.fitBoundsAsync(this.wpArray[this.wpIndex].getBounds())
    //             eventBus.$emit('make-row-active', this.wpArray[this.wpIndex]._layers[this.wpArray[this.wpIndex]._leaflet_id - 1].feature.properties.id)
    //             eventBus.$emit('change-cell-id', this.wpArray[this.wpIndex]._layers[this.wpArray[this.wpIndex]._leaflet_id - 1].feature.properties.id)
    //
    //             console.log(this.wpArray[this.wpIndex], this.wpArray, this.wpIndex, 'wpi')
    //
    //             this.wpIndex-=1
    //         }
    //     },
    //     ]
    // }).addTo(this.map)
    // upButton = new L.Control.EasyButton({
    //     position: 'bottomright',
    //     states: [{
    //         stateName: 'on',        // name the state
    //         icon:      'bi bi-caret-right-fill',               // and define its properties
    //         title:     'move to next cell',      // like its title
    //         onClick: (btn) => {       // and its callback
    //             // eventBus.$emit('move-next')
    //
    //             console.log("mm", goodCells)
    //             console.log("mm", goodCellsId)
    //
    //             // this.fitBoundsAsync(this.wpArray[this.wpIndex].getBounds())
    //             console.log(this.wpArray.length, this.CellsBuRoute.length, 'len')
    //             eventBus.$emit('make-row-active', this.wpArray[this.wpIndex]._layers[this.wpArray[this.wpIndex]._leaflet_id - 1].feature.properties.id)
    //             eventBus.$emit('change-cell-id', this.wpArray[this.wpIndex]._layers[this.wpArray[this.wpIndex]._leaflet_id - 1].feature.properties.id)
    //
    //             console.log(this.wpArray[this.wpIndex], this.wpArray, this.wpIndex, 'wpi')
    //
    //             this.wpIndex+=1
    //         }
    //     },
    //     ]
    // }).addTo(this.map)

    // let customControl2 = L.Control.extend({
    //     options: {
    //         position: 'bottomright'
    //     },
    //
    //     onAdd: (map) => {
    //
    //         eventBus.$on('change-cell-id', (value) => {
    //             container.value = value
    //         })
    //
    //         var container = L.DomUtil.create('input');
    //         container.button_state = true;
    //         container.type = "button";
    //         container.title = "Cells by route";
    //         container.value = cellByRouteId
    //         container.style.backgroundColor = 'white';
    //         container.style.width = '75px';
    //         container.style.height = '24px';
    //
    //         return container;
    //     }
    // });
    //
    // this.map.addControl(this.cellButton = new customControl2())

    let customControl1 = L.Control.extend({
      options: {
        position: "bottomright",
      },

      onAdd: (map) => {
        let container = L.DomUtil.create("input");
        container.button_state = true;
        container.type = "button";
        container.title = "Add charts by route";
        container.value = "Route";
        container.className = "button-14-no-hover";

        container.onclick = () => {
          router.push("routes");
        };

        return container;
      },
    });

    // this.customControl = this.customControl.bind(this)

    eventBus.$on("add-primar-controls", () => {
      if (this.customControl === null)
        this.map.addControl((this.customControl = new customControl())); //TODO control
      // this.map.addControl(this.customControl1 = new customControl1()) //TODO control
    });
    eventBus.$on("remove-primar-controls", () => {
      this.map.removeControl(this.customControl);
      this.map.removeControl(this.customControl1);
    });
    // eventBus.$on('a1', () => {
    //     this.map.removeControl(customControl1)
    // })

    // this.ScaleStateControl = new L.Control.EasyButton({
    //     position: 'topright',
    //     states: [{
    //         stateName: 'on',        // name the state
    //         icon:      'bi bi-file-diff-fill',               // and define its properties
    //         title:     'Turn autoband off',      // like its title
    //         onClick: (btn) => {       // and its callback
    //             // eventBus.$emit('toggle-autoband', true)
    //             this.autoscale_bands = false
    //             btn.state('off');    // change state on click!
    //         }
    //     }, {
    //         stateName: 'off',
    //         icon:      'bi bi-file-diff',
    //         title:     'Turn autoband on',
    //         onClick: (btn) => {
    //             // eventBus.$emit('toggle-autoband', false)
    //             this.autoscale_bands = true
    //             btn.state('on');
    //         }
    //     }]
    // }).addTo(this.map)

    // var drawControl = new L.Control.Draw({
    //     draw: {
    //         polygon: false,
    //         marker: false,
    //         circle: false,
    //         polyline: false,
    //         circlemarker: false
    //
    //     },
    // }).addTo(this.map);
    // new L.Control.EasyButton({
    //     position: 'bottomleft',
    //     states: [{
    //         icon:      'bi bi-square',               // and define its properties
    //         title:     'Select by map bounds',      // like its title
    //         onClick: (btn) => {       // and its callback
    //             eventBus.$emit("bound-select")
    //         }
    //     }]
    // }).addTo(this.map)

    eventBus.$on("bound-select", () => {
      if (this.chartsSelectable) {
        Object.keys(this.ChartsLayers).forEach((lg) => {
          if (this.map.hasLayer(this.ChartsLayers[lg])) {
            Object.keys(this.ChartsData[lg]).forEach((field) => {
              Object.keys(this.ChartsData[lg][field]).forEach((cell) => {
                if (cell !== "lg") {
                  const mapBounds = this.map.getBounds();
                  let bounds =
                    this.ChartsData[lg][field][cell].cell.getBounds();
                  if (mapBounds.contains(bounds)) {
                    this.onCellClicked(cell);
                  }
                }
              });
            });
          }
        });
        this.dispatchSelectedCells();
      }
    });
    this.map.on("zoomend", () => {
      // alert(1)
      // var count = 0
      // this.ChartsLayers.coastal.lg.eachLayer(l => {
      //     count++
      // })
      // console.log(count, 'count')
      console.log(this.map.getZoom(), "zoom");
      // this.map.setMinZoom(0)
      // if (this.autoscale_bands) {
      this.scaleCharts();
      // }

      let checkBoxes = document.getElementsByClassName(
        "leaflet-control-layers-selector"
      );

      Object.keys(checkBoxes).forEach((digit) => {
        checkBoxes[digit].onclick = () => {
          this.disableAutobands();
        };
      });
    });
    this.map.on("click", () => {
      // this.setCeatalogueNotHistory(true);
      // alert("click")
      // this.scaleCharts();

      console.log("---------------");

      // Убираем временную подсветку при клике по карте
      this.clearHighlightRectangle();

      // this.map.contextmenu.hide();
    });

    // Убираем временную подсветку только при перетаскивании карты (не при zoom)
    this.map.on("drag", () => {
      // Не убираем подсветку во время программного зумирования
      if (!this.isProgrammaticZoom) {
        this.clearHighlightRectangle();
      }
    });

    this.map.on("polylinemeasure:toggle", (e) => {
      if (e.sttus) {
        Object.keys(this.ChartsLayers).forEach((cl) => {
          this.ChartsLayers[cl].removeFrom(this.map);
        });
        eventBus.$emit("draw-control-toggle", true);
      } else if (!e.sttus) {
        this.ChartsLayers.overview.addTo(this.map);
        // this.ChartsLayers.general.addTo(this.map);
        // this.ChartsLayers.approach.addTo(this.map);
        eventBus.$emit("draw-control-toggle", false);
      }
    });

    // this.map.on('polylinemeasure:finish', () => {
    //     //TODO: enable spinner (doesnt work)
    //     eventBus.$emit('go-spinny', true)
    //     this.map.spin(true);
    //     let y = setTimeout(() => {
    //         // console.log(this.pMeasure)
    //         this.computeCharts()
    //             .then(() => {
    //                 eventBus.$emit('go-spinny', false);
    //                 // eventBus.$emit('charts-loaded');
    //                 this.map.spin(false);
    //             })
    //     }, 1000)
    //
    // });
    // this.map.on('polylinemeasure:move', () => {
    //     this.clearSelectedCells();
    //     this.computeCharts();
    // });
    // this.map.on('polylinemeasure:clear', () => {
    //     this.clearSelectedCells();
    //
    // });

    this.paneControl = new PaneControl(this.map);

    eventBus.$on("cell-clicked", (id) => {
      // let mapBounds = this.map.getBounds()
      //
      // if (this.chartsSelectable) {
      //     Object.keys(this.ChartsLayers).forEach(lg => {
      //         if (this.map.hasLayer(this.ChartsLayers[lg])) {
      //             Object.keys(this.ChartsData[lg]).forEach(field => {
      //                 Object.keys(this.ChartsData[lg][field]).forEach(cell => {
      //                     if (cell !== 'lg') {
      //                         let bounds = this.ChartsData[lg][field][cell].cell.getBounds()
      //                         if (mapBounds.contains(bounds)) {
      //                             this.onCellClicked(cell)
      //                         }
      //                     }
      //                 })
      //             })
      //         }
      //     })
      //     this.dispatchSelectedCells();
      // }
      console.log(this.chartsSelectable);
      if (this.chartsSelectable) {
        this.onCellClicked(id).then(() => {
          // Если это был toggle (переключение disabled), не отправляем в store
          if (this.skipDispatchSelectedCells) {
            console.log("Пропускаем dispatchSelectedCells для toggle");
            this.skipDispatchSelectedCells = false;
            // Сбрасываем общую цену при переключении состояния ячейки через карту
            eventBus.$emit("reset-total-price-if-needed");
            return;
          }
          // Always append when clicking individual cells, don't replace cart
          this.dispatchSelectedCells(true);
        });
      }
    });

    // eventBus.$on('aaaa', (text) => {
    //     console.log(text)
    // })

    eventBus.$on("fix-scale", () => {
      // this.layersControl.remove();
      // this.layersControl = L.control.layers({}, this.overlayMaps, {collapsed: false}).addTo(this.map);
      // alert("fix")
      // this.map.fire("viewreset");
      // this.map.fire("resize");
      // this.map.fire("zoomlevelschange");
      // this.scaleCharts()
      // this.map.setZoom(12)
      // this.scaleCharts()
    });

    eventBus.$on("draw-map-spinner", (flag) => {
      this.map.spin(flag);

      // this.map.remove(text2)
      // this.map.remove(customControl1)

      // eventBus.$emit('a1')

      // text2.updateContent("")
      // this.map.removeControl(customControl1)

      // $("#info_text")[0].innerHTML = "aaaa";
    });

    eventBus.$on("s63-order-finished1", () => {
      this.clearSelectedCells();
    });
    eventBus.$on("pane2cell", (payload) => {
      const prev = this.autoscale_bands;
      // Убираем предыдущую временную подсветку при навигации к новой ячейке
      this.clearHighlightRectangle();
      // this.autoscale_bands = false
      this.showHighlight(
        payload["id"],
        payload["items"],
        payload["color"]
      ).then(() => {
        // this.autoscale_bands = true
      });
    });
    eventBus.$on("find-cells", (e) => {
      // alert("find clicked")
      console.log(e);

      // if (!isShipSelected)
      //     eventBus.$emit("select-ship-from-chart")
      // else
      this.findChartsOnRightClick(e);
    });
    eventBus.$on("purchased-cell-clicked", (id) => {
      // alert("cell clicked1")
      // TODO
      // this.setSpecialTiles('https://win1hetz.bgeo.fi:5005/' + id + '/{z}/{x}/{y}');
      console.log("purchased cell clicked", id);
    });
    eventBus.$on("s63-order-finished2", () => {
      this.setMultiTiles();
    });
    eventBus.$on("sumary-open", () => {
      this.map.ChartsLayers.unavailable.addTo(this.map);
    });
    eventBus.$on("show-cell-on-map", (url) => {
      // TODO
      // this.setSpecialTiles(url);
    });
    eventBus.$on("make-cell-active", (id) => {
      // alert(id)
      const m = this.match(id);
      const model = store.state.current.cart.s63cells.find((x) => x.id == id);

      // console.log(id, m, 'match')

      // alert(m)
      let lefId = Object.keys(m.cell._layers)[0];
      const layer = m.cell._layers[lefId];
      console.log(layer, "layer");
      // layer.setStyle({color: colorControl.ACTIVE_CELL_COLOR})
      const isSelected = m.scope === "selectedCells";
      console.log(layer, id, isSelected, "mra");
      let type = m.cell._layers[lefId].feature.properties.unavailable
        ? "unavailable"
        : m.cell._layers[lefId].feature.properties.type;
      m.cell.bringToFront();
      colorControl.changeActiveCell(
        layer,
        id,
        isSelected,
        m.cell,
        type,
        model.disabled
      );
      console.log(m.cell.getLayer, "layer");
      // this.disableAutobands()
      // const selected = store.state.current.cart.s63cells
      // // console.log(selected, feature.properties.id)
      // let cellIsAlreadySelected = false
      // if (selected && selected.find(enc => enc.id === feature.properties.productId)){
      //     cellIsAlreadySelected = true;
      // }
      // colorControl.changeActiveCell(layer, id, cellIsAlreadySelected)
    });

    // Обработчик для временной подсветки ячеек
    eventBus.$on("highlight-cell-temporary", (settings) => {
      this.highlightCellTemporary(settings);
    });
    // console.log("c--02", new Date().getMinutes(), new Date().getSeconds())

    this.drawLogbookState();

    // Инициализация функционала выбора области на карте
    this.initAreaSelection();
  }

  // Инициализация функции выбора области
  initAreaSelection() {
    // Переменная для хранения текущего прямоугольника выбора
    this.currentAreaSelection = null;

    // Подписываемся на события активации/деактивации выбора области
    eventBus.$on("activate-area-selection", () => {
      this.activateAreaSelection();
    });

    eventBus.$on("clear-area-selection", () => {
      this.clearAreaSelection();
    });

    // Обработчик для очистки выбранных ячеек при очистке корзины
    eventBus.$on("clear-selected-cells", () => {
      this.clearSelectedCells();
    });
  }

  // Активация режима выбора области
  activateAreaSelection() {
    console.log("Активация режима выбора области");

    // Очищаем предыдущее выделение, если есть
    this.clearAreaSelection();

    // Изменяем курсор карты
    this.map.getContainer().style.cursor = "crosshair";

    // Переменные для отслеживания начальной точки
    let startLatLng = null;
    let isDrawing = false;

    // Обработчик начала рисования (mousedown)
    const onMouseDown = (e) => {
      if (e.originalEvent.button !== 0) return; // Только левая кнопка мыши

      isDrawing = true;
      startLatLng = e.latlng;

      // Предотвращаем стандартное поведение карты
      e.originalEvent.preventDefault();
      e.originalEvent.stopPropagation();
    };

    // Обработчик движения мыши (mousemove)
    const onMouseMove = (e) => {
      if (!isDrawing || !startLatLng) return;

      // Убираем предыдущий прямоугольник
      if (this.currentAreaSelection) {
        this.map.removeLayer(this.currentAreaSelection);
      }

      // Создаем новый прямоугольник
      const bounds = L.latLngBounds(startLatLng, e.latlng);
      this.currentAreaSelection = L.rectangle(bounds, {
        color: "#00ff00",
        weight: 2,
        opacity: 0.8,
        fillColor: "#00ff00",
        fillOpacity: 0.2,
      }).addTo(this.map);
    };

    // Обработчик завершения рисования (mouseup)
    const onMouseUp = (e) => {
      if (!isDrawing || !startLatLng) return;

      isDrawing = false;

      // Создаем финальный прямоугольник
      const bounds = L.latLngBounds(startLatLng, e.latlng);

      // Проверяем, что область достаточно большая
      const minSize = 0.01; // минимальный размер в градусах
      if (
        Math.abs(bounds.getNorth() - bounds.getSouth()) < minSize ||
        Math.abs(bounds.getEast() - bounds.getWest()) < minSize
      ) {
        console.log("Область слишком маленькая");
        this.clearAreaSelection();
        return;
      }

      // Убираем обработчики событий
      this.map.off("mousedown", onMouseDown);
      this.map.off("mousemove", onMouseMove);
      this.map.off("mouseup", onMouseUp);

      // Возвращаем обычный курсор
      this.map.getContainer().style.cursor = "";

      // Отправляем событие с координатами выбранной области
      const areaBounds = {
        north: bounds.getNorth(),
        south: bounds.getSouth(),
        east: bounds.getEast(),
        west: bounds.getWest(),
      };

      console.log("Область выбрана:", areaBounds);
      eventBus.$emit("area-selection-complete", areaBounds);
    };

    // Добавляем обработчики событий
    this.map.on("mousedown", onMouseDown);
    this.map.on("mousemove", onMouseMove);
    this.map.on("mouseup", onMouseUp);

    // Отключаем стандартные интерактивности карты во время рисования
    this.map.dragging.disable();
    this.map.touchZoom.disable();
    this.map.doubleClickZoom.disable();
    this.map.scrollWheelZoom.disable();
    this.map.boxZoom.disable();
    this.map.keyboard.disable();

    // Включаем интерактивности обратно после завершения
    const restoreInteractivity = () => {
      this.map.dragging.enable();
      this.map.touchZoom.enable();
      this.map.doubleClickZoom.enable();
      this.map.scrollWheelZoom.enable();
      this.map.boxZoom.enable();
      this.map.keyboard.enable();
    };

    // Восстанавливаем интерактивность при завершении
    this.map.once("mouseup", restoreInteractivity);
  }

  // Очистка выделенной области
  clearAreaSelection() {
    if (this.currentAreaSelection) {
      this.map.removeLayer(this.currentAreaSelection);
      this.currentAreaSelection = null;
    }

    // Возвращаем обычный курсор
    this.map.getContainer().style.cursor = "";

    // Убираем все обработчики событий выбора области
    this.map.off("mousedown");
    this.map.off("mousemove");
    this.map.off("mouseup");

    // Восстанавливаем интерактивности карты
    this.map.dragging.enable();
    this.map.touchZoom.enable();
    this.map.doubleClickZoom.enable();
    this.map.scrollWheelZoom.enable();
    this.map.boxZoom.enable();
    this.map.keyboard.enable();
  }

  showAppState(
    aindex,
    lat,
    lon,
    azimuth,
    id,
    isActive,
    name,
    route,
    sog,
    email,
    gpsDate,
    appStateDate,
    routeJson = [],
    posbyship = false
  ) {
    this.scaleCharts();
    super.showAppState(
      aindex,
      lat,
      lon,
      azimuth,
      id,
      isActive,
      name,
      route,
      sog,
      email,
      gpsDate,
      appStateDate,
      (routeJson = []),
      (posbyship = false)
    );
  }

  // devideRouteBySegments(){
  //     var segmentedRoute = [];
  //     let wpoints = store.state.routes.route
  //     let route = []
  //
  //     wpoints.forEach(wp => {
  //         // console.log("wp -- ", wp)
  //         route.push([wp.lon, wp.lat])
  //     })
  //
  //     // console.log("wp -- ", route)
  //
  //     const routeStringLine = lineString(route);
  // }

  findChartsOnRightClick(e) {
    // if (e === 'hide') {
    //     this.map.contextmenu.hide();
    // } else {
    const latlon = e.e.latlng;
    const type = e.props.type;
    const id = e.props.id;

    const title = e.props.name;
    const purchased = e.props.unavailable ? "<br>" + "" : "";
    const paid = e.props.unavailable ? "(bought) " : "";
    const m = this.match(id);
    const scope = m.scope;
    const field = m.field;
    // // console.log(m, id)
    const addChart = function (lg, cell) {
      console.log(lg, cell);
      if (lg !== "selectedCells") eventBus.$emit("cell-clicked", cell);
      else eventBus.$emit("purchased-cell-clicked", cell);
    };
    // console.log(scope, this.ChartsData[scope])
    // if (scope && this.ChartsData[scope]){
    //     console.log("a1")
    //     const clickedChart = scope == 'selectedCells' ? this.ChartsData.selectedCells[id] : this.ChartsData[scope][field][id];
    //     const clickedChartId = clickedChart.cell
    //     // colorControl.changeActiveCell(clickedChart)
    //
    //     // console.log(cell.getBounds())
    //
    //     const activeBounds = clickedChartId.getBounds();
    //     console.log(this.map.hasLayer(this.ChartsLayers['overview'], 'lg'))
    //     Object.keys(this.ChartsLayers).forEach(lg => {
    //         if (this.map.hasLayer(this.ChartsLayers[lg])) {
    //             console.log(lg, 'lg')
    //             console.log(this.map.hasLayer(this.ChartsLayers[lg]), 'lg')
    //             console.log(this.map.hasLayer(this.ChartsLayers['overview']), 'lg')
    //             Object.keys(this.ChartsData[lg]).forEach(field => {
    //                 Object.keys(this.ChartsData[lg][field]).forEach(cell => {
    //                     if (cell !== 'lg') {
    //                         let bounds = this.ChartsData[lg][field][cell].cell.getBounds()
    //                         if (!scope) console.log(scope, 'a6')
    //
    //                         // console.log(bounds.contains(activeBounds), this.scope2digit[lg] <= this.scope2digit[scope], 'a6')
    //                         // console.log(this.scope2digit[lg], this.scope2digit[scope], 'a6')
    //                         // console.log(cell, 'a6')
    //                         if (!this.scope2digit[scope]) console.log(scope, cell, id, 'a6');
    //                         else console.log(scope, cell, id, 'a6')
    //
    //                         if (bounds.contains(activeBounds) && this.scope2digit[lg] < this.scope2digit[scope]) {
    //                             addChart(lg, cell)
    //                             console.log(cell, lg, 'a5')
    //                         }
    //                     }
    //                 })
    //             })
    //         }
    //     })
    // }

    addChart(scope, id);
    eventBus.$emit("make-row-active", id);
    // this.map.contextmenu.removeAllItems();
    // // ДОБАВЛЕНИЕ
    // // const icon = (!Object.keys(this.ChartsData.selectedCells).find(x => x === id)) ? "bi bi-bag-plus-fill": 'bi bi-bag-dash'
    // const icon = (!Object.keys(this.ChartsData.selectedCells).find(x => x === id)) ? "bi bi-toggle-off" : 'bi bi-toggle-on'
    //
    // this.map.contextmenu.addItem(
    //     {
    //         text: paid + "<span class='smt1'>" + id + "</span>" + " " + "<i>" + type + "</i>" + "<br>" + "<b>" + title + "</b>",
    //         // + purchased ? "<b>Purchased</b>" : "",
    //         iconCls: purchased ? 'bi bi-cash-coin' : this.chartsSelectable ? icon : '',
    //         hideOnSelect: true,
    //         callback: !purchased ?
    //             function () {
    //                 eventBus.$emit('cell-clicked', id);
    //             } :
    //             function () {
    //                 eventBus.$emit('purchased-cell-clicked', id);
    //             },
    //         index: 0
    //     }
    // )
    // this.map.contextmenu.addItem(
    //     {
    //         text: "underlying cells",
    //         disabled: true,
    //         separator: true,
    //         index: 1
    //     }
    // )

    // this.map.contextmenu.showAt(latlon);
    //     })
    //     // УДАЛЕНИЕ
    //     Object.keys(this.ChartsData.selectedCells).forEach(key => {
    //         if (key != 'lg') {
    //             let cell = this.ChartsData.selectedCells[key].cell;
    //             console.log(cell)
    //             let bounds = cell.getBounds();
    //             if (this.isPointInsidePolygon(bounds, latlon) && key !== id) {
    //                 let type = cell._layers[cell._leaflet_id - 1].feature.properties.type;
    //                 this.map.contextmenu.addItem(
    //                     {
    //                         text: "<i class='bi bi-bag-dash'></i> " + type + " " + key,
    //                         // hideOnSelect: false,
    //                         callback: function () {
    //                             eventBus.$emit('cell-clicked', key);
    //                         },
    //                     }
    //                 )
    //             }
    //         }
    //     })
    // }
  }

  setCeatalogueNotHistory(flag) {
    if (this.highLight) {
      this.highLight.eachLayer((layer) => {
        layer.setStyle({ color: "#656565" });
      });
      this.highLight.clearLayers();
    }
    if (flag === false) {
      Object.keys(this.ChartsLayers).forEach((cl) => {
        this.ChartsLayers[cl].removeFrom(this.map);
      });
      this.highLight = new L.layerGroup();
      this.highLight.addTo(this.map);
      this.makeChartsUnselectable();
    } else if (flag === true && !this.catalogueNotHistory) {
      this.highLight.removeFrom(this.map);
      this.ChartsLayers.overview.addTo(this.map);
      // this.ChartsLayers.general.addTo(this.map);
      // this.ChartsLayers.approach.addTo(this.map);
    }
    this.catalogueNotHistory = flag;
  }

  fitBoundsAsync(bounds) {
    return new Promise((resolve) => {
      this.map.fitBounds(bounds);
      resolve();
    });
  }
  // setViewAsync(pt){
  //     return new Promise( resolve =>{
  //         this.map.setView(pt);
  //         resolve()
  //     })
  // }

  showHighlight(currentId, items, color) {
    console.log(
      "showHighlight called with:",
      currentId,
      "|",
      items,
      "|",
      color
    );
    return new Promise((resolve) => {
      let id = currentId;
      let match = this.match(id);
      let field = match.field;
      let scope = match.scope;

      if (scope === null) {
        console.warn("showHighlight: Cell not found for ID:", id);
        resolve();
        return;
      }

      console.log("===============");
      console.log("---------------");
      console.log(scope, id, field);
      console.log("2 ---------------");

      let cell =
        scope == "selectedCells"
          ? this.ChartsData.selectedCells[id].cell
          : this.ChartsData[scope][field][id].cell;

      if (!cell) {
        console.warn("showHighlight: Cell object not found for ID:", id);
        resolve();
        return;
      }

      console.log("4 ---------------");

      // Поднимаем ячейку наверх для лучшей видимости
      cell.bringToFront();

      let bounds = cell.getBounds();
      console.log("0000 bounds:", bounds);
      let cellCenter = bounds.getCenter();
      console.log("0000 center:", cellCenter);

      // Получаем информацию о ячейке для определения zoom
      let bandType = cell._layers[cell._leaflet_id - 1].feature.properties.type;
      let cellName = cell._layers[cell._leaflet_id - 1].feature.properties.name;

      // Определяем подходящий zoom в зависимости от типа ячейки
      let zoomLevel = 9;
      if (bandType === "overview") zoomLevel = 3;
      else if (bandType === "general") zoomLevel = 5;
      else if (bandType === "coastal") zoomLevel = 7;
      else if (bandType === "approach") zoomLevel = 9;
      else if (bandType === "harbour") zoomLevel = 11;
      else if (bandType === "berthing") zoomLevel = 13;

      console.log(
        "showHighlight: Setting view to center:",
        cellCenter,
        "with zoom:",
        zoomLevel,
        "for type:",
        bandType
      );

      // Центрируем карту на ячейке с соответствующим zoom
      this.map.setView(cellCenter, zoomLevel);

      // Показываем временный tooltip с информацией о ячейке
      this.showCellTooltip(cell, id, bandType, cellName);

      console.log("showHighlight: Cell highlighted successfully:", id);
      resolve();
    });
  }

  // Метод для отображения tooltip с информацией о ячейке
  showCellTooltip(cell, id, bandType, cellName) {
    try {
      // Находим любой слой ячейки для отображения tooltip
      const layerKey = Object.keys(cell._layers)[0];
      if (layerKey && cell._layers[layerKey]) {
        const layer = cell._layers[layerKey];

        // Создаем содержимое tooltip
        const tooltipContent = `${id} (${bandType})<br>${cellName || ""}`;

        // Открываем tooltip в центре ячейки
        const cellCenter = cell.getBounds().getCenter();
        layer
          .bindTooltip(tooltipContent, {
            permanent: false,
            sticky: false,
            direction: "center",
          })
          .openTooltip(cellCenter);

        console.log("showCellTooltip: Tooltip shown for cell:", id);

        // Автоматически скрываем tooltip через 5 секунд
        setTimeout(() => {
          if (layer.getTooltip()) {
            layer.closeTooltip();
          }
        }, 5000);
      }
    } catch (error) {
      console.error("Error showing cell tooltip:", error);
    }
  }

  isPointInsidePolygon(poly, pt) {
    let polyPoints = poly;
    let x = pt.lat,
      y = pt.lng;
    // let x = 60, y = 25;
    let ne = poly._northEast;
    let sw = poly._southWest;

    let inside = false;
    // console.log(x, y, ne, sw)

    inside = x <= ne.lat && x >= sw.lat && y <= ne.lng && y >= sw.lng;

    return inside;
  }

  isRouteIntersectPolygon(route, polygon) {}

  computeCharts(polyLine) {
    if (!cellButton) {
      let customControl2 = L.Control.extend({
        options: {
          position: "bottomright",
        },

        onAdd: (map) => {
          eventBus.$on("change-cell-id", (value) => {
            container.value = value;
          });

          let container = L.DomUtil.create("input");
          container.button_state = true;
          container.type = "button";
          container.title = "Cells by route";
          container.value = cellByRouteId;
          container.style.backgroundColor = "white";
          container.style.width = "75px";
          container.style.height = "24px";

          return container;
        },
      });

      this.map.addControl((this.cellButton = new customControl2()));

      this.upButton = new L.Control.EasyButton({
        position: "bottomright",
        states: [
          {
            stateName: "on", // name the state
            icon: "bi bi-caret-down-fill", // and define its properties
            title: "Move to next cell", // like its title
            onClick: (btn) => {
              // and its callback
              // eventBus.$emit('move-next')

              console.log("mm", goodCells);
              console.log("mm", goodCellsId);

              // this.fitBoundsAsync(this.wpArray[this.wpIndex].getBounds())
              console.log(this.wpArray.length, this.CellsBuRoute.length, "len");
              eventBus.$emit(
                "make-row-active",
                this.wpArray[this.wpIndex]._layers[
                  this.wpArray[this.wpIndex]._leaflet_id - 1
                ].feature.properties.id
              );
              eventBus.$emit(
                "change-cell-id",
                this.wpArray[this.wpIndex]._layers[
                  this.wpArray[this.wpIndex]._leaflet_id - 1
                ].feature.properties.id
              );

              console.log(
                this.wpArray[this.wpIndex],
                this.wpArray,
                this.wpIndex,
                "wpi"
              );

              this.wpIndex += 1;
            },
          },
        ],
      }).addTo(this.map);

      this.downButton = new L.Control.EasyButton({
        position: "bottomright",
        states: [
          {
            stateName: "on", // name the state
            icon: "bi bi-caret-up-fill", // and define its properties
            title: "Move to previous cell", // like its title
            onClick: (btn) => {
              // and its callback
              // eventBus.$emit('move-prev' )
              console.log(this.wpIndex, "wpi");
              // this.fitBoundsAsync(this.wpArray[this.wpIndex].getBounds())
              eventBus.$emit(
                "make-row-active",
                this.wpArray[this.wpIndex]._layers[
                  this.wpArray[this.wpIndex]._leaflet_id - 1
                ].feature.properties.id
              );
              eventBus.$emit(
                "change-cell-id",
                this.wpArray[this.wpIndex]._layers[
                  this.wpArray[this.wpIndex]._leaflet_id - 1
                ].feature.properties.id
              );

              console.log(
                this.wpArray[this.wpIndex],
                this.wpArray,
                this.wpIndex,
                "wpi"
              );

              this.wpIndex -= 1;
            },
          },
        ],
      }).addTo(this.map);
    }

    // this.map.addControl(this.customControl1 = new customControl1())

    let wpoints = store.state.routes.route;
    let route = [];
    this.routeSegments = [];
    let cells = [];
    let products = [];

    for (let i = 0; i < wpoints.length; i += 1) {
      let wp = wpoints[i];
      route.push([wp.lon, wp.lat]);
      if (i > 0) {
        let prevWp = wpoints[i - 1];
        this.routeSegments.push([
          [prevWp.lon, prevWp.lat],
          [wp.lon, wp.lat],
        ]);
      }
    }
    // console.log(this.routeSegments, 'srp')

    const routeStringLine = turf.lineString(route);
    // console.log(routeStringLine, 'srp')

    const routeStringLineSplit = turf.lineChunk(routeStringLine, 2, {
      units: "kilometers",
    });
    // console.log(routeStringLineSplit, 'srp')

    let points = [];
    routeStringLineSplit.features.forEach((point) => {
      points.push(point.geometry.coordinates[0]);
      points.push(point.geometry.coordinates[1]);
    });

    let uniquePoints = Array.from(
      new Set(points.map(JSON.stringify)),
      JSON.parse
    );
    console.log(uniquePoints, "srp points");

    let cellBands = ["berthing", "harbour", "approach", "coastal", "general"];
    let cellTypes = ["bigCells", "midCells", "lilCells"];

    goodCells = [];
    goodCellsId = [];
    this.CellsBuRoute = [];
    this.wpIndex = 0;

    let pg = null;
    let bn = "";

    uniquePoints.forEach((point) => {
      let stopFlag = false;

      let lat = point[0];
      let lon = point[1];
      let pt = turf.point([lat, lon]);

      if ((bn === "berthing" || bn === "harbour") && pg) {
        if (turf.booleanPointInPolygon(pt, pg)) {
          return;
        }
      }

      cellBands.every((band) => {
        if (stopFlag) return false;
        cellTypes.every((type) => {
          if (stopFlag) return false;

          Object.keys(this.ChartsData[band][type]).every((cellId) => {
            if (this.ChartsData[band][type][cellId].cell) {
              let cell = this.ChartsData[band][type][cellId].cell;
              let coordinates =
                cell._layers[cell._leaflet_id - 1].feature.geometry.coordinates;

              pg = turf.polygon([
                [
                  coordinates[0][0],
                  coordinates[0][1],
                  coordinates[0][2],
                  coordinates[0][3],
                  coordinates[0][0],
                ],
              ]);
              stopFlag = turf.booleanPointInPolygon(pt, pg);
              if (stopFlag) {
                bn = band;
                if (!goodCellsId.includes(cellId)) {
                  goodCells.push(cell);
                  goodCellsId.push(cellId);
                  this.CellsBuRoute.push(cell);
                  console.log("srp +", cellId);
                }
                return false;
              }
            }
            return true;
          });
          return true;
        });
        return true;
      });
    });
    this.wpArray = PythonArray.from(this.CellsBuRoute);

    goodCells.forEach((cell) => {
      if (
        !cells.find(
          (x) => x == cell._layers[cell._leaflet_id - 1].feature.properties.id
        ) &&
        !products.find(
          (x) =>
            x == cell._layers[cell._leaflet_id - 1].feature.properties.productId
        )
      ) {
        cells.push(cell);
      }
    });

    console.log("aaa", cells);

    cells.forEach((cell) => {
      this.onCellClicked(
        cell._layers[cell._leaflet_id - 1].feature.properties.id
      );
    });
    this.dispatchSelectedCells();
    console.log(this.upButton, "upbutton");
    setTimeout(() => {
      this.upButton.button.click();
    }, 1000);
  }

  computeCharts1(polyLine) {
    let wpoints = store.state.routes.route;
    let route = [];
    this.routeSegments = [];

    for (let i = 0; i < wpoints.length; i += 1) {
      let wp = wpoints[i];
      route.push([wp.lon, wp.lat]);
      if (i > 0) {
        let prevWp = wpoints[i - 1];
        this.routeSegments.push([
          [prevWp.lon, prevWp.lat],
          [wp.lon, wp.lat],
        ]);
      }
    }
    console.log(this.routeSegments, "srp");

    const routeStringLine = turf.lineString(route);

    let ltlList;
    return new Promise((resolve, error) => {
      console.log(this.pMeasure._arrPolylines, "aa");

      let x = this.pMeasure._arrPolylines[0];
      if (!x) {
        eventBus.$emit("go-spinny", false);
        // eventBus.$emit('charts-loaded');
        this.map.spin(false);
        error();
      }

      ltlList = x.polylinePath._latlngs;
      x.polylinePath.addTo(this.legsGroup);

      let cells = [];
      let products = [];
      let coordss = null;
      let latlon = null;
      let x1 = [];
      let x2 = [];
      let x3 = [];

      this.CellsBuRoute = [];
      var interPts = [];
      this.newSegments = [];
      this.routeSegments.forEach((seg) => {
        var newSeg = [seg[0], seg[1]];
        let match = false;
        Object.keys(this.ChartsData).forEach((key) => {
          if (match) return;
          if (key != "selectedCells") {
            Object.keys(this.ChartsData[key]).forEach((field) => {
              if (match) return;
              if (field != "lg") {
                Object.keys(this.ChartsData[key][field]).forEach((id) => {
                  if (match) return;
                  if (this.ChartsData[key][field][id].cell) {
                    let cell = this.ChartsData[key][field][id].cell;
                    if (
                      cell._layers[cell._leaflet_id - 1].feature.properties
                        .type != "overview" &&
                      cell._layers[cell._leaflet_id - 1].feature.properties
                        .type != "general"
                    ) {
                      // console.log(ce
                      let bounds =
                        cell._layers[cell._leaflet_id - 1].getBounds();

                      // console.log(bounds)
                      let arr =
                        cell._layers[cell._leaflet_id - 1].feature.geometry
                          .coordinates;
                      let lastPoint = arr[0][0];
                      arr[0].push(lastPoint);
                      let line1 = turf.lineString(arr[0]);
                      // let intersection = lin
                      const segments = this.routeSegments;

                      var segLine = turf.lineString(seg);
                      var inter = lineIntersect(line1, segLine);

                      // let ppp = turf.point([56.10773, 16.932678])
                      let ppp = turf.point(seg[0]);

                      if (inter.features.length > 0) {
                        x1.push(inter);
                        interPts = [];
                        // this.CellsBuRoute.push(cell)
                        inter.features.forEach((fea) => {
                          interPts.push({
                            coords: turf.point(fea.geometry.coordinates),
                            cell: cell,
                          });
                        });
                        var iii = interPts.sort((fea1, fea2) => {
                          let dist1 = turf.distance(fea1.coords, ppp);
                          let dist2 = turf.distance(fea2.coords, ppp);
                          if (dist1 < dist2) {
                            return -1;
                          } else if (dist1 === dist2) {
                            return 0;
                          } else {
                            return 1;
                          }
                        });
                        x2.push(iii);
                      }
                      if (interPts.length > 0) {
                        // console.log(inter, 'inter')

                        for (let i = 0; i < interPts.length; i += 1) {
                          let coords = interPts[i].coords.geometry.coordinates;
                          console.log(interPts[i], "eee");
                          x3.push(turf.distance(coords, seg[0]));

                          // let x = [seg[0],seg[1] ]
                          // x.splice(i+1, 0, coords);
                          newSeg.splice(i + 1, 0, coords);
                          if (
                            !cells.find(
                              (x) =>
                                x ==
                                cell._layers[cell._leaflet_id - 1].feature
                                  .properties.id
                            ) &&
                            !products.find(
                              (x) =>
                                x ==
                                cell._layers[cell._leaflet_id - 1].feature
                                  .properties.productId
                            )
                          ) {
                            this.CellsBuRoute.push(interPts[i]);

                            // cells.push(cell._layers[cell._leaflet_id - 1].feature.properties.id)
                            // products.push(cell._layers[cell._leaflet_id - 1].feature.properties.productId)
                          }
                        }
                      }

                      console.log(this.routeSegments, "rs");
                    }
                  }
                });
              }
            });
          }
        });
        this.newSegments.push(newSeg);
      });
      this.CellsBuRoute.forEach((i) => {
        console.log(i, "iii");
        let cell = i.cell;
        cells.push(cell._layers[cell._leaflet_id - 1].feature.properties.id);
        products.push(
          cell._layers[cell._leaflet_id - 1].feature.properties.productId
        );
      });
      this.wpArray = PythonArray.from(this.CellsBuRoute);
      this.wpIndex = -1;
      // console.log("b1++", x1)
      // console.log(x3, 'x3')
      // console.log(this.CellsBuRoute, 'cbr')
      //
      // console.log("ddd")
      // console.log("ddd", interPts)
      //
      // interPts.forEach(item => {
      //     console.log("ddd", item.geometry.coordinates)
      // })
      //
      // x1.forEach(item => {
      //     console.log("b1++1", x1)
      //     // item.features.sort( (fea)=>{
      //     //     return turf.distance(fea.geometry.coordinates, seg[0])
      //     // })
      //
      //     // console.log("b1++2", x2)
      // })
      // x2.forEach(feas=> {
      //     feas.forEach(fea => {
      //         console.log(fea.geometry.coordinates, 'b1++2')
      //
      //     })
      // })

      // })
      // console.log("a--2", new Date().getMinutes(), new Date().getSeconds())
      // console.log(coordss);
      // console.log(latlon);
      // console.log(cells)

      this.segmentedRoute = [];

      this.newSegments.forEach((seg) => {
        seg.forEach((pt) => {
          let duplicateCount = 0; //seg.filter(coords => (Math.abs(pt[0] - coords[0]) < 0.00001 && Math.abs(pt[0] - coords[0]) < 0.00001));
          this.segmentedRoute.forEach((coords) => {
            // seg.forEach(coords => {
            if (
              Math.abs(pt[0] - coords[0]) < 0.001 &&
              Math.abs(pt[0] - coords[0]) < 0.001
            ) {
              duplicateCount += 1;
            }
            // })
          });
          if (duplicateCount < 1) this.segmentedRoute.push(pt);
          console.log(duplicateCount, "dupl");
        });
      });
      this.newSegmentedRoute = [];
      console.log(this.CellsBuRoute, "tsr");
      for (let i = 0; i < this.segmentedRoute.length; i += 1) {
        let wp = this.segmentedRoute[i];
        console.log(wp, "wp");
        this.newSegmentedRoute.push([wp[1], wp[0]]);
        if (i > 0) {
          let prevWp = this.segmentedRoute[i - 1];
          this.newSegmentedRoute.push([
            [prevWp[1], prevWp[0]],
            [wp[1], wp[0]],
          ]);
        }
      }
      // this.newSegmentedRoute.forEach(segment => {
      //     let match = false;
      //     console.log(segment, 'segment')
      //     var latlngs = [
      //         segment,
      //     ];
      //
      //     var polyline = L.polyline(latlngs, {color: 'red'}).addTo(this.map)
      //     console.log(polyline, 'poly')
      //     Object.keys(this.ChartsData).forEach(key => {
      //         if (match) return;
      //         if (key != 'selectedCells') {
      //             Object.keys(this.ChartsData[key]).forEach(field => {
      //                 if (match) return;
      //                 if (field != 'lg') {
      //                     Object.keys(this.ChartsData[key][field]).forEach(id => {
      //                         if (match) return;
      //                         if (this.ChartsData[key][field][id].cell) {
      //
      //                             let cell = this.ChartsData[key][field][id].cell
      //                             // if (cell._layers[cell._leaflet_id - 1].feature.properties.type != 'overview'
      //                             //     && cell._layers[cell._leaflet_id - 1].feature.properties.type != 'general'
      //                             //     && cell._layers[cell._leaflet_id - 1].feature.properties.type == 'coastal') {
      //                             //
      //                             //     let bounds = cell._layers[cell._leaflet_id - 1].getBounds();
      //                             //     let lineBounds = polyline._bounds;
      //                             //     console.log(polyline, 'bounds')
      //                             //
      //                             //     if (bounds.contains(lineBounds)) {
      //                             //         console.log('aaaa-- ', cell)
      //                             //         match = true
      //                             //
      //                             //
      //                             //
      //                             //     }
      //                             //
      //                             // }
      //                         }
      //                     })
      //                 }
      //             })
      //         }
      //     })
      // })

      // console.log("b--1", new Date().getMinutes(), new Date().getSeconds())
      new Set(cells).forEach((id) => {
        this.onCellClicked(id);
      });
      // console.log("b--2", new Date().getMinutes(), new Date().getSeconds())
      this.dispatchSelectedCells();
      resolve();
      this.pMeasure.remove();
      this.makeChartsSelectable();
    });
  }

  clearSelectedCells() {
    // alert(2)
    console.log("clearSelectedCells: ВЫЗВАН! Стек вызова:", new Error().stack);
    console.log(file, "clear selected cells");
    let linksToProducts = this.catalogsStore.getLinks;
    // let linksToProducts = store.state.charts.s63.products.linksToProducts;
    // let products = store.state.charts.s63.products.all;
    let products = this.catalogsStore.getProducts;

    console.log("aaaa a1 ", products);
    // console.log("aaaa a2 ", products1)

    let toRemoveList = [];
    let productsList = [];
    let selc = this.ChartsData?.selectedCells ?? {};

    console.log("clearSelectedCells: текущие selectedCells:", selc);

    Object.keys(selc).forEach((c) => {
      if (c != "lg") {
        productsList.push(linksToProducts[c]);
      }
    });
    console.log("clearSelectedCells: productsList:", productsList);
    new Set(productsList).forEach((x) => {
      toRemoveList.push(
        products.find((y) => y.id === x).productCellList.productCells[0].id
      );
    });
    console.log("clearSelectedCells: toRemoveList:", toRemoveList);
    toRemoveList.forEach((x) => {
      console.log("clearSelectedCells: удаляем ячейку", x);
      this.onCellClicked(x);
    });
    // this.dispatchSelectedCells();
  }

  switchCell(cellId, type) {
    // Используем существующий метод onCellClicked для переключения состояния ячейки
    this.onCellClicked(cellId);
  }

  highlightCell(cellName) {
    console.log("highlightCell called with:", cellName);

    // Получаем momentary store для доступа к данным маршрута
    const momentaryStore = useMomentaryStore();

    // Отладка структуры store
    console.log(
      "Momentary store cellsByRoute:",
      momentaryStore.charts?.cellsByRoute
    );

    // Сначала пробуем найти в momentaryStore.charts.cellsByRoute (данные по маршруту)
    let cell = null;
    if (momentaryStore.charts?.cellsByRoute?.length > 0) {
      cell = momentaryStore.charts.cellsByRoute.find(
        (routeCell) =>
          routeCell.name === cellName ||
          routeCell.id === cellName ||
          routeCell.productId === cellName
      );
      console.log("Found in route cells:", cell);
    } else {
      console.log("No cellsByRoute in momentary store or empty array");
    }

    // Если не найдено в маршруте, ищем в корзине
    if (!cell) {
      console.log(
        "Available cells in cart:",
        store.state.current.cart.s63cells.map((c) => ({
          id: c.id,
          name: c.name,
          EncId: c.EncId,
          enc_id: c.enc_id,
        }))
      );

      cell = store.state.current.cart.s63cells.find(
        (cartCell) =>
          cartCell.id === cellName ||
          cartCell.name === cellName ||
          cartCell.EncId === cellName ||
          cartCell.enc_id === cellName
      );
      console.log("Found in cart:", cell);
    }

    // Если всё ещё не найдено, попробуем найти среди слоёв карты
    if (!cell && this.allCells) {
      cell = this.allCells.find(
        (mapCell) =>
          mapCell.id === cellName ||
          mapCell.name === cellName ||
          mapCell.properties?.name === cellName ||
          mapCell.properties?.id === cellName
      );
      console.log("Found in map cells:", cell);
    }

    if (
      cell &&
      cell.west !== undefined &&
      cell.east !== undefined &&
      cell.north !== undefined &&
      cell.south !== undefined
    ) {
      // Вычисляем центр ячейки
      const centerLat = (cell.north + cell.south) / 2;
      const centerLng = (cell.west + cell.east) / 2;

      console.log("Moving to cell center:", centerLat, centerLng);

      // Перемещаемся к центру ячейки
      this.map.setView([centerLat, centerLng], this.map.getZoom());
    } else {
      console.warn("Cell not found in cart:", cellName);
    }
  }

  selectChartsByRoute() {
    this.clearRoute();
    this.add_pMeasure(true);
    // console.log(this.pMeasure)

    let a = document.getElementById("polyline-measure-control");
    if (a) a.hidden = false;
  }

  makeChartsSelectable() {
    this.chartsSelectable = true;
    // this.setCeatalogueNotHistory(true)
  }

  makeChartsUnselectable() {
    this.chartsSelectable = false;
  }

  getSelectedCells() {
    console.log(
      "getSelectedCells: начало, проверяем selectedCells:",
      Object.keys(this.ChartsData.selectedCells)
    );
    let stuf = [];
    Object.keys(this.ChartsData.selectedCells).forEach((key) => {
      if (key != "lg") {
        let cell = this.ChartsData.selectedCells[key].cell;
        let lefId = Object.keys(cell._layers)[0];
        console.log(
          "getSelectedCells: обрабатываем ячейку",
          key,
          "productId:",
          cell._layers[lefId].feature.properties.productId
        );

        // let otherStuf = this.catalogsStore.getItems.filter( x => {
        //     return x.id == cell._layers[lefId].feature.properties.productId;
        // })
        stuf.push(cell._layers[lefId].feature.properties.productId);
      }
    });
    console.log("getSelectedCells: результат", stuf, "stuf");
    return stuf;
  }

  scaleCharts() {
    console.log("scale:start");
    let zoom = this.map.getZoom();
    console.log(zoom);
    // alert(this.autoscale_bands)
    if (this.autoscale_bands) {
      Object.keys(this.ChartsLayers).forEach((name) => {
        if (name != "unavailable" && name != "s102") {
          console.log(name);
          const minz = this.getMinZFromUsageBand(name);
          const maxz = this.getMaxZFromUsageBand(name);

          if (zoom >= maxz - 7) {
            console.log(name + " removed");
            this.ChartsLayers[name].removeFrom(this.map);
          } else {
            if (zoom >= minz - 7) {
              console.log(name + " added");
              this.ChartsLayers[name].addTo(this.map);
            } else {
              console.log(name + " removed");
              this.ChartsLayers[name].removeFrom(this.map);
            }
          }
        }
      });
    }
    // alert(zoom)
    if (zoom < 3) {
      this.refreshLayers("bigCells");
    } else if (zoom < 4) this.refreshLayers("midCells");
    else if (zoom < 9) this.refreshLayers("lilCells");
    console.log("scale:end");
  }

  refreshLayers(cells = null) {
    Object.keys(this.ChartsLayers).forEach((key) => {
      this.ChartsLayers[key].clearLayers();
      if (cells) {
        this.ChartsData[key][cells].lg.addTo(this.ChartsLayers[key]);
      }
    });
  }

  refreshData() {
    if (this.ChartsData.selectedCells)
      this.ChartsData.selectedCells.lg.removeFrom(this.map);
    this.ChartsData = {
      overview: new ChartsType(),
      general: new ChartsType(),
      coastal: new ChartsType(),
      approach: new ChartsType(),
      harbour: new ChartsType(),
      berthing: new ChartsType(),
      unavailable: new ChartsType(),
      // s102: new ChartsType(),
      selectedCells: { lg: L.layerGroup() },
    };

    Object.keys(this.ChartsData).forEach((key) => {
      if (key != "selectedCells") {
        this.ChartsData[key].lilCells.lg.addTo(this.ChartsLayers[key]);
        this.ChartsData[key].midCells.lg.addTo(this.ChartsLayers[key]);
        this.ChartsData[key].bigCells.lg.addTo(this.ChartsLayers[key]);
      }
    });
    this.ChartsData.selectedCells.lg.clearLayers();
    this.ChartsData.selectedCells.lg.addTo(this.map);
  }

  drawCell(data, styleType) {
    // alert("draw cell")
    let zind = data.properties.zind;
    if (zind) {
      zind = String(zind);
      this.paneControl.do(zind);
    }
    let pane = zind ? zind : data.properties.type;

    let cellStyle = { color: "red", fillOpacity: 0.1, weight: 2, opacity: 1 };
    switch (styleType) {
      case 1:
        cellStyle = { color: "pink", fillOpacity: 0.05, weight: 1, opacity: 1 };
        break;
      case 2:
        cellStyle = {
          color: colorControl.DEFAULT_CELL_COLOR,
          fillOpacity: 0.05,
          weight: 1,
          opacity: 1,
        };
        break;
      case 3:
        cellStyle = { color: "#dfff9b", fillOpacity: 0, weight: 2, opacity: 1 };
        break;
    }
    const toggleCellColor = (id, layer, feature) => {
      // console.log(selected)
      if (id === feature.properties.id) {
        console.log(id, feature.properties.id);
        layer.setStyle({ color: colorControl.ACTIVE_CELL_COLOR });
      } else {
        layer.setStyle({ color: colorControl.SELECTED_CELL_COLOR });
        console.log(feature.properties.id);
      }
      // eventBus.$off('make-cell-active');
    };
    var cell = L.geoJson(data, {
      onEachFeature: function (feature, layer) {
        layer.bindContextMenu();
        // layer.bindPopup(feature.properties.name, {pane: 'aaa'});
        const purchased = feature.properties.unavailable
          ? "<br>" + "<b>Purchased</b>"
          : "";
        layer.bindTooltip(
          feature.properties.id +
            " (" +
            feature.properties.type +
            ")" +
            "<br>" +
            feature.properties.name +
            "<br>" +
            purchased,
          { sticky: true, pane: "aaa" }
        );
        layer.on("click", () => {
          // alert("layer clicked")
          console.log("ChartsLeaf: клик по ячейке", feature.properties.id);

          if (!feature.properties.unavailable) {
            // Ячейка доступна для покупки - вызываем событие cell-clicked
            eventBus.$emit("cell-clicked", feature.properties.id);
          } else {
            // Ячейка уже куплена - вызываем событие purchased-cell-clicked
            eventBus.$emit("purchased-cell-clicked", feature.properties.id);
          }

          // eventBus.$emit('find-cells', {e: e, props: feature.properties});

          console.log(layer, "layer");
        });
        // layer.on('hover',  () => {layer.openTooltip();})
        // layer.on('contextmenu', () => {
        //     eventBus.$emit('find-cells', 'hide')
        // })
      },
      style: cellStyle,
    });

    let field = this.matchFieldBySize(cell);
    let lefId = Object.keys(cell._layers)[0];
    let type = cell._layers[lefId].feature.properties.unavailable
      ? "unavailable"
      : cell._layers[lefId].feature.properties.type;
    if (field && cell._layers[lefId].feature.properties.id && type) {
      this.ChartsData[type][field][cell._layers[lefId].feature.properties.id] =
        {};
      this.ChartsData[type][field][
        cell._layers[lefId].feature.properties.id
      ].cell = cell;
      cell.addTo(this.ChartsData[type][field].lg);
    }
  }

  resetMainLayer() {
    this.mainLayer.remove();
    this.mainLayer = L.tileLayer(
      "https://api.probki.net/map/{z}/{x}/{y}"
    ).addTo(this.map);
    if (this.layersControl) this.layersControl.remove();
  }

  resetAll() {
    // this.resetMainLayer();
    // this.clearCellslayer();
    //this.clearAppStates();
  }

  drawAllCells(allCharts) {
    console.log("1122 primar", allCharts);
    console.log("c--1", new Date().getMinutes(), new Date().getSeconds());
    // alert(1)
    let flag;

    store.dispatch("current/addLoadingMarker", "my_lead|drawAllCells");

    eventBus.$emit("loading-data", true);
    // this.setDefaultTiles();
    this.clearCellslayer();
    // store.dispatch('addS63Items', [])

    // let summary = store.state.charts.s63.summary;
    let summary = []; // TODO remove

    var x = 0;
    const chData = this.catalogsStore.getChartsFeatures;
    this.ChartsFeatures = chData ? chData : [];
    if (!chData) {
      console.log(allCharts);

      allCharts = allCharts.filter(function (e) {
        return e.productSpecNumber !== 111;
      });

      allCharts.forEach((chart) => {
        if (chart.usageBand != "s102") {
          let borders = [
            [
              [chart.west, chart.north],
              [chart.east, chart.north],
              [chart.east, chart.south],
              [chart.west, chart.south],
            ],
          ];
          let geometry = { type: "Polygon", coordinates: borders };

          let chartFeatures = getS63CKTInfo(chart.id);
          let price = chartFeatures.price;

          let notForSale = false;
          if (summary) {
            notForSale = summary.find((x) => x.id === chart.id) ? true : false;
          }

          // if (notForSale) console.log(notForSale)
          let periods = chartFeatures.period;

          let chartType =
            chart.usageBand === "s102"
              ? "s102"
              : utils.getBandName(chart.usageBand);

          if (!notForSale) {
            const z = ((ne, sw) => {
              let d = Math.hypot(ne.lat - sw.lat, ne.lng - sw.lng);
              return 10 / d;
            })(
              { lat: chart.east, lng: chart.north },
              { lat: chart.west, lng: chart.south }
            );

            let pane = Number(this.map.getPane(chartType).style.zIndex);

            var zi = Math.round(pane + z);
            zi = zi > pane + 9 ? pane + 9 : zi;
            x++;
          }

          if (!chart.productId) {
            flag = true;
            console.log(chartType);
          }

          var cellJson = {
            type: "Feature",
            properties: {
              name: chart.title,
              id: chart.id,
              type: chartType,
              price: price,
              unavailable: notForSale,
              periods: periods,
              productId: chart.productId,
              zind: zi,
            },
            geometry: geometry,
          };

          // let styleType = (store.state.charts.s63.products.multiPart[chart.productId]) ? 1 : 2;
          let styleType = this.catalogsStore.getMiltiItems[chart.productId]
            ? 1
            : 2;
          if (notForSale) styleType = 3;

          this.drawCell(cellJson, styleType);
          this.ChartsFeatures.push({
            cellJson: cellJson,
            styleType: styleType,
          });
        }
      });
      if (flag) {
        // alert('PROBLEMA, ' + file)
        console.log("PROBLEMA, " + file);
      }
    } else {
      this.ChartsFeatures.forEach((feat) => {
        this.drawCell(feat.cellJson, feat.styleType);
      });
    }

    this.scaleCharts();

    // let urls = [];
    // summary.forEach( chart => {
    //     const url =  'https://win1hetz.bgeo.fi:5005/'+chart.id+'/{z}/{x}/{y}';
    //     urls.push(url);
    // })
    // this.setMultiTiles(urls)
    this.addChartLayers();
    this.setMultiTiles();
    // console.log(Object.keys(this.ChartsData.s102.lilCells).length)

    eventBus.$emit("loading-data", false);

    store.dispatch("current/removeLoadingMarker", "my_lead|drawAllCells");

    // this.scaleCharts();

    // this.map.setZoom(2);

    let checkBoxes = document.getElementsByClassName(
      "leaflet-control-layers-selector"
    );

    Object.keys(checkBoxes).forEach((digit) => {
      checkBoxes[digit].onclick = () => {
        this.disableAutobands();
      };
    });
    store.state.current.cart.s63cells.forEach((cell) => {
      this.onCellClicked(cell.id);
      if (cell.disabled) {
        this.unselectCell(cell.id);
      }
      var flag = false;
      if (!flag) {
        let cellObj = this.match(cell.id).cell;
        this.fitBoundsAsync(cellObj.getBounds()).then(() => {
          let zoom = this.map.getZoom() - 1;
          let center = this.map.getCenter();
          this.map.setView(center, zoom);
        });
        // this.map.setViewAsync(cellObj.getCenter())
        flag = true;
      }
    });
    if (store.state.routes.use_for_order) {
      // alert(1)
      this.computeCharts(store.state.routes.route);
      // alert(2)
    }
    colorControl.init(this.activePane, this.ChartsLayers, this.ChartsData);
    this.makeChartsSelectable();
    if (this.catalogsStore.getChartsFeatures === undefined)
      this.catalogsStore.addChartsFeatures(this.ChartsFeatures);
    // store.commit('setChartsFeatures', this.ChartsFeatures)

    // setTimeout(() => {
    //     eventBus.$emit('charts-loaded');
    // }, 5000)

    // alert(2)
    console.log("c--2", new Date().getMinutes(), new Date().getSeconds());
    console.log("aaaa 3");
  }

  disableAutobands() {
    // this.autoscale_bands = false
    // this.customControl.getContainer().button_state = false
    // this.customControl.getContainer().value = "Autobands ☐"
  }

  unselectCell(id) {
    const cell = this.match(id).cell;
    const model = store.state.current.cart.s63cells.find((x) => x.id == id);
    // let cell =this.ChartsData.selectedCells[id].cell
    // let lefId = Object.keys(cell._layers)[0]
    // let newScope = cell._layers[lefId].feature.properties.type
    // this.ChartsData[newScope][field][id] = {};
    // this.ChartsData[newScope][field][id].cell = cell;
    // // let color = '#656565';
    // let color = colorControl.DEFAULT_CELL_COLOR;
    //
    // // cellStyle = {color: "#dfff9b", fillOpacity: 0, dashArray: 2, weight: 2, opacity: 1};
    //
    // this.ChartsData[newScope][field][id].cell.setStyle({color: colorControl.DEFAULT_CELL_COLOR, fillOpacity: 0.05, dashArray: 1, weight: 1, opacity: 1});
    // this.ChartsData.selectedCells.lg.removeLayer(cell);
    // cell.addTo(this.ChartsData[newScope][field].lg);
    // delete this.ChartsData.selectedCells[id];
    colorControl.syncSelectedStatus(id, true, cell, model.disabled);
    // cell.!model.disabled();
    // cell.addTo(this.activePane)
  }

  replaceCell(scope, field, id, showAnimation = true) {
    const model = store.state.current.cart.s63cells.find((x) => x.id == id);

    // Проверяем, уже ли ячейка в корзине (в selectedCells)
    const isAlreadyInCart = scope === "selectedCells";
    const cartItem = this.cartStore.getCart.find((item) => item.id === id);

    // Если ячейка уже в корзине, переключаем её состояние вместо перемещения
    if (cartItem && isAlreadyInCart) {
      console.log("replaceCell: ячейка", id, "уже в корзине, переключаем disabled:", !cartItem.disabled);
      // Переключаем disabled флаг в store
      this.cartStore.updateCell({ id: id, type: "switch" });
      // Визуально переключаем окантовку на карте
      this.toggleCellVisualSelection(id);
      // Устанавливаем флаг, чтобы не отправлять снова в dispatchSelectedCells
      this.skipDispatchSelectedCells = true;
      return;
    }

    let cell =
      scope == "selectedCells"
        ? this.ChartsData.selectedCells[id].cell
        : this.ChartsData[scope][field][id].cell;
    let lefId = Object.keys(cell._layers)[0];
    let newScope =
      scope == "selectedCells"
        ? cell._layers[lefId].feature.properties.type
        : "selectedCells";

    if (!cell._layers[lefId].feature.properties.unavailable) {
      if (newScope == "selectedCells") {
        console.log("replaceCell: добавляем ячейку", id, "в selectedCells");
        this.ChartsData.selectedCells[id] = {};
        this.ChartsData.selectedCells[id].cell = cell;
        let color = colorControl.SELECTED_CELL_COLOR;
        // cell.setStyle({color: color, weight: 4, opacity: 1, fillOpacity: 0.2});
        this.ChartsData[scope][field].lg.removeLayer(cell);
        cell.addTo(this.ChartsData.selectedCells.lg);
        delete this.ChartsData[scope][field][id];
        colorControl.syncSelectedStatus(id, true, cell, false);
        console.log(
          "replaceCell: ячейка",
          id,
          "добавлена в selectedCells. Всего selectedCells:",
          Object.keys(this.ChartsData.selectedCells).filter((k) => k !== "lg")
            .length
        );

        // 🎨 Отправляем событие для анимации новой ячейки только если showAnimation = true
        if (showAnimation) {
          eventBus.$emit("cell-added-to-cart", id);
        }
      } else {
        console.log(
          "replaceCell: удаляем ячейку",
          id,
          "из selectedCells в",
          newScope
        );
        this.ChartsData[newScope][field][id] = {};
        this.ChartsData[newScope][field][id].cell = cell;
        const color = colorControl.DEFAULT_CELL_COLOR;
        //cell.setStyle({color: color, weight: 4, opacity: 1, fillOpacity: 0.2});
        this.ChartsData.selectedCells.lg.removeLayer(cell);
        cell.addTo(this.ChartsData[newScope][field].lg);
        delete this.ChartsData.selectedCells[id];
        colorControl.syncSelectedStatus(id, true, cell, true);
        console.log(
          "replaceCell: ячейка",
          id,
          "удалена из selectedCells. Всего selectedCells:",
          Object.keys(this.ChartsData.selectedCells).filter((k) => k !== "lg")
            .length
        );
      }
    }
  }

  // Переключает визуальное отображение отключенной ячейки
  toggleCellVisualSelection(id) {
    const cell = this.ChartsData.selectedCells[id]?.cell;
    if (!cell) return;

    const cartItem = this.cartStore.getCart.find((item) => item.id === id);
    if (!cartItem) return;

    // Обновляем стиль в зависимости от disabled флага
    if (cartItem.disabled) {
      // Отключенная ячейка - меньшая полупрозрачность
      console.log("toggleCellVisualSelection: отключаем визуально", id);
      cell.setStyle({
        color: colorControl.SELECTED_CELL_COLOR,
        weight: 2,
        opacity: 0.5,
        fillOpacity: 0.1,
      });
    } else {
      // Включенная ячейка - полный стиль
      console.log("toggleCellVisualSelection: включаем визуально", id);
      cell.setStyle({
        color: colorControl.SELECTED_CELL_COLOR,
        weight: 4,
        opacity: 1,
        fillOpacity: 0.2,
      });
    }
  }

  match(id) {
    // console.log('cccc: match', id)
    let f = null;
    let s = null;
    let cell = null;
    Object.keys(this.ChartsData).forEach((scope) => {
      Object.keys(this.ChartsData[scope]).forEach((field) => {
        // console.log('cccc: match', scope, field, id)
        if (scope != "selectedCells") {
          if (this.ChartsData[scope][field][id]) {
            // console.log(this.ChartsData[scope][field][id], field)
            f = field;
            s = scope;
            cell = this.ChartsData[scope][field][id].cell;
          }
        } else if (scope == "selectedCells") {
          // console.log('a4')

          if (this.ChartsData.selectedCells[id]) {
            // Убираем избыточное логирование, которое создавало спам в консоли
            // console.log(id, 'dispatch-selected-cells')
            s = scope;
            f = this.matchFieldBySize(this.ChartsData.selectedCells[id].cell);
            cell = this.ChartsData.selectedCells[id].cell;
          }
        }
      });
    });
    return { scope: s, field: f, cell: cell };
  }

  dispatchSelectedCells(append = false) {
    this.setMultiTiles();
    let s = this.getSelectedCells();
    // if (s.length > 0) store.dispatch('addS63Items', s)
    if (s.length > 0) this.cartStore.addCells(s, append);
  }

  onGetId(id) {
    let m = this.match(id);
    let field = m.field;
    let scope = m.scope;
    if (field && scope) {
      this.replaceCell(scope, field, id);
    } else {
      // alert("Cell " + id + " dosen't exist")
      console.log("onGetIdcell not found", id);
    }
  }

  async onCellClicked(id, isComplex = false) {
    // console.log("onCellClicked: вызван для ячейки", id);
    console.log(
      "ChartsLeaf: вызван onCellClicked для ячейки:",
      id,
      "isComplex:",
      isComplex
    );

    const groups = this.catalogsStore.getMiltiItems;
    const countries = this.catalogsStore.getCountries;
    let links = this.catalogsStore.getLinks;

    const countryCode = id.substring(0, 2);
    const country = countries.find((c) => c.code === countryCode);

    console.log("EEEE code", countryCode);
    console.log("EEEE country", country);

    if (
      country &&
      country.possibleSubscriptionTypeList &&
      country.possibleSubscriptionTypeList.possibleSubscriptionTypes
    ) {
      const cellPeriods =
        country.possibleSubscriptionTypeList.possibleSubscriptionTypes.map(
          (t) => t.id.toString()
        );
      const newAvailablePeriods = this.availablePeriods.filter((p) =>
        cellPeriods.includes(p)
      );

      console.log("EEEE new periods", cellPeriods, newAvailablePeriods);

      if (newAvailablePeriods.length < this.availablePeriods.length) {
        console.log("EEEE new periods flag");
        this.availablePeriods = newAvailablePeriods;
        eventBus.$emit("update-available-periods", this.availablePeriods);
      }
    }

    // Проверяем, что это составной объект
    if (groups[id] && groups[id].id === id) {
      isComplex = true;

      // // Код страны для получения bandPrice
      // let countryCode = groups[id].countryId
      //
      // const country = countries.find(c => c.id === countryCode);
      // const subscriptionTypes = country.possibleSubscriptionTypeList.possibleSubscriptionTypes
      //
      // const has0 = subscriptionTypes.some(item => item.id === 0);
      // const has1 = subscriptionTypes.some(item => item.id === 1);
      // const has4 = subscriptionTypes.some(item => item.id === 4);

      // if (has0 && has1 && has4)
      //     alert("all")
      // else if (has0 && has1 && )
      //     alert("0 1")
      // else if (has0)
      //     alert("0")

      // console.log("EEEE", country);
      // const subscriptionTypeIds = country && country.possibleSubscriptionTypes
      //     ? country.possibleSubscriptionTypes.map(type => type.id)
      //     : [];
      // console.log("EEEE", subscriptionTypeIds);
    }

    let items = this.catalogsStore.getItems;
    let products = this.catalogsStore.getProducts;
    // let items = store.state.charts.s63.primar_map_info

    // console.log("aaaa1", items)
    // console.log("aaaa2", items1)

    if (!isComplex) {
      if (!items.find((item) => item.id === id)) {
        if (id.trim().length > 0) eventBus.$emit("cell-not-found", id);
      }

      if (groups[links[id]]) {
        let arr = groups[links[id]].productCellList.productCells;
        arr.forEach((key) => {
          // console.log(key, id)
          this.onGetId(key.id);
        });
      } else {
        this.onGetId(id);
      }
    } else {
      if (!products.find((item) => item.id === id)) {
        if (id.trim().length > 0) eventBus.$emit("cell-not-found", id);
      }

      // alert('Found complex')

      let product = products.find((item) => item.id === id);
      console.log("complex", product);

      product.productCellList.productCells.forEach((cell) => {
        console.log("complex", cell.id);
        this.onGetId(cell.id);
      });
    }
  }

  matchFieldBySize(cell) {
    let ne = cell.getBounds()._northEast;
    let sw = cell.getBounds()._southWest;

    let d = Math.sqrt(
      Math.pow(ne.lat - sw.lat, 2) + Math.pow(ne.lng - sw.lng, 2)
    );
    if (d >= 80) {
      return "bigCells";
    } else if (d >= 30) {
      return "midCells";
    } else if (d > 0) {
      return "lilCells";
    }
    return null;
  }

  clearCellslayer() {
    // alert(1)
    this.refreshLayers();
    this.refreshData();
  }

  rmChartLayers() {
    Object.keys(this.ChartsLayers).forEach((cl) => {
      this.ChartsLayers[cl].removeFrom(this.map);
    });
    this.layersControl.remove();
  }

  addChartLayers() {
    // this.ChartsLayers.overview.addTo(this.map);
    // this.ChartsLayers.general.addTo(this.map);
    // this.ChartsLayers.coastal.addTo(this.map);
    // this.ChartsLayers.harbour.addTo(this.map);
    // this.ChartsLayers.approach.addTo(this.map);
    // this.ChartsLayers.berthing.addTo(this.map);
    // alert(3)
    this.ChartsLayers.unavailable.addTo(this.map);
    this.rmChartLayers();

    if (!CURRENT_PRODUCT.is_navicom)
      //TODO control
      this.layersControl = L.control
        .layers({}, this.overlayMaps, { collapsed: false })
        .addTo(this.map);
    // this.ChartsLayers.general.addTo(this.map);
    // this.ChartsLayers.overview.addTo(this.map);
    this.ChartsLayers.unavailable.addTo(this.map);
    this.scaleCharts();
  }

  isDefaultTiles(flag) {
    this.is_default_tiles = flag;
  }

  // changeTiles(URL){
  //     this.mainLayer.remove();
  //     this.mainLayer = L.tileLayer(URL);
  //     this.mainLayer.addTo(this.map);
  // }
  // setDefaultTiles(){
  //     if (!this.is_default_tiles){
  //         // this.layersControl.remove();
  //         console.log('setDefaultTiles', file)
  //         this.changeTiles("https://api.probki.net/map/{z}/{x}/{y}");
  //         // this.addChartLayers();
  //         this.osmLayer.remove();
  //         this.isDefaultTiles(true);
  //     }
  // }
  // setSpecialTiles(URL){
  //     // this.layersControl.remove();
  //     this.osmLayer.addTo(this.map);
  //     this.changeTiles(URL);
  //     // this.rmChartLayers();
  //     this.isDefaultTiles(false);
  //     // this.layersControl = L.control.layers(
  //     //     {osmLayer: this.osmLayer, mainLayer: this.mainLayer},
  //     //     this.overlayMaps, {collapsed: false})
  // }
  static getSpecialTileLayer(id, bounds) {
    const url = "https://win1hetz.bgeo.fi:5005/" + id + "/{z}/{x}/{y}";
    // const minZ = this.getMinZFromUsageBand(type);

    const tileLayer = L.tileLayer(url, {
      minZoom: 2,
      maxZoom: 20,
      bounds: bounds,
    });
    return tileLayer;
  }

  getMinZFromUsageBand(chartType) {
    let minZ = 9;
    switch (chartType) {
      case "overview":
        minZ = 9;
        break;
      case "general":
        minZ = 11;
        break;
      case "coastal":
        minZ = 13;
        break;
      case "approach":
        minZ = 15;
        break;
      case "harbour":
        minZ = 16;
        break;
      case "berthing":
        minZ = 18;
        break;
    }
    return minZ;
  }

  getMaxZFromUsageBand(chartType) {
    let minZ = 9;
    switch (chartType) {
      case "overview":
        minZ = 11;
        break;
      case "general":
        minZ = 13;
        break;
      case "coastal":
        minZ = 15;
        break;
      case "approach":
        minZ = 16;
        break;
      case "harbour":
        minZ = 18;
        break;
      case "berthing":
        minZ = 21;
        break;
    }
    return minZ;
  }

  setMultiTiles(remove = false) {
    // this.updateMultiTiles();
    // if (this.multiTilesStateControl._currentState.stateName === 'on'){
    //     this.clearMultiTiles();
    //     if (!remove) this.addMultiTiles()
    // }
  }

  clearMultiTiles() {
    if (this.tilesGroup) {
      Object.keys(this.tilesGroup).forEach((type) => {
        this.tilesGroup[type].forEach((tile) => {
          tile.remove();
        });
      });
    }
  }

  addMultiTiles() {
    this.mainLayer.remove();
    this.osmLayer.remove();
    this.osmLayer.addTo(this.map);
    this.isDefaultTiles(false);
    Object.keys(this.tilesGroup).forEach((type) => {
      console.log(this.tilesGroup[type], type);
      this.tilesGroup[type].forEach((TL) => {
        TL.addTo(this.map);
      });
    });
  }

  updateMultiTiles() {
    this.tilesGroup = {
      overview: [],
      general: [],
      coastal: [],
      approach: [],
      harbour: [],
      berthing: [],
    };
    // console.log(this.ChartsLayers, this.ChartsData)
    Object.keys(this.ChartsData.unavailable).forEach((level) => {
      Object.keys(this.ChartsData.unavailable[level]).forEach((id) => {
        if (id !== "lg") {
          const cell = this.ChartsData.unavailable[level][id].cell;
          const lefId = Object.keys(cell._layers)[0];
          const type = cell._layers[lefId].feature.properties.type;
          const bounds = cell.getBounds();
          const TL = ChartsLeaf.getSpecialTileLayer(id, bounds);
          this.tilesGroup[type].push(TL);
        }
      });
    });

    Object.keys(this.ChartsData.selectedCells).forEach((id) => {
      if (id !== "lg") {
        console.log("a5");
        const cell = this.ChartsData.selectedCells[id].cell;
        const lefId = Object.keys(cell._layers)[0];
        const type = cell._layers[lefId].feature.properties.type;
        const bounds = cell.getBounds();
        const TL = ChartsLeaf.getSpecialTileLayer(id, bounds);
        this.tilesGroup[type].push(TL);
      }
    });
  }

  drawLogbookState() {
    this.logbookGroup.clearLayers();

    if (this.logbookStore.getLogsCount > 0) {
      let report = this.logbookStore.getLatestShipLog;

      console.log("gggg", report);

      let iconImg = require("../../assets/ship_1tx_green.png");
      let icon = L.icon({
        iconUrl: iconImg,
        iconSize: [20, 40],
        iconAnchor: [10, 20],
      });

      let text = dayjs(report.time).format("YYYY-MM-DD HH:mm:ss") + "<br>";
      let positionMarker = new L.marker([report.pos.lat, report.pos.lon], {
        icon: icon,
        rotationAngle: report.hdg,
      });

      positionMarker.bindTooltip(text, {
        permanent: true,
        direction: "top",
        offset: L.point(0, -17),
      });
      positionMarker.addTo(this.logbookGroup);
    }
  }

  redrawMap(URL) {
    this.setCeatalogueNotHistory(false);
    console.log(URL);
    this.mainLayer.remove();
    //this.map.setView(coordinates, zoom_level);

    // map.setMaxZoom(maxzoom);
    // map.setMinZoom(minzoom);
    this.map.setMaxZoom(20);
    this.map.setMinZoom(2);
    this.map.setZoom(4);

    let osmLayer = L.tileLayer("https://api.probki.net/map/{z}/{x}/{y}");
    this.layersControl.remove();
    this.mainLayer = L.tileLayer(URL);
    this.layersControl = L.control
      .layers({ osmLayer: osmLayer, mainLayer: this.mainLayer })
      .addTo(this.map);

    osmLayer.addTo(this.map);
    this.mainLayer.addTo(this.map);
  }

  // Метод для отображения маршрута (перенесен из ChartsByRouteLeaf)
  showRoute() {
    let points = this.routesStore.getShipWaypoints;

    // Проверяем, что есть точки маршрута и группа инициализирована
    if (!points || points.length === 0) {
      console.log("ChartsLeaf: нет точек маршрута для отображения");
      return;
    }

    if (!this.routeGroup) {
      console.warn(
        "ChartsLeaf: routeGroup не инициализирована, пропускаем отрисовку маршрута"
      );
      return;
    }

    console.log("ChartsLeaf: отрисовываем маршрут с", points.length, "точками");

    // Очищаем предыдущий маршрут
    this.routeGroup.clearLayers();

    points.forEach((point, index) => {
      let tooltip = "WP" + index;
      let isPermanent = false;
      if (index === 0) {
        tooltip = "<div style='color:#16ba16;'>Start</div>";
        isPermanent = true;
      } else if (index === points.length - 1) {
        tooltip = "<div style='color:#eda405;'>Finish</div>";
        isPermanent = true;
      }

      let newMarker = new L.circleMarker([point.lat, point.lon], {
        radius: 5,
        weight: 2,
        color:
          index === 0
            ? "#16ba16"
            : index === points.length - 1
            ? "#eda405"
            : "#1976d2",
        fillColor:
          index === 0
            ? "#16ba16"
            : index === points.length - 1
            ? "#eda405"
            : "#1976d2",
        fillOpacity: 0.8,
      });

      newMarker.bindTooltip(tooltip, {
        permanent: isPermanent,
        direction: "top",
        offset: [0, -10],
      });

      this.routeGroup.addLayer(newMarker);
    });

    // Отрисовываем линии между точками
    if (points.length > 1) {
      let routeLine = L.polyline(
        points.map((p) => [p.lat, p.lon]),
        {
          color: "#1976d2",
          weight: 3,
          opacity: 0.8,
        }
      );
      this.routeGroup.addLayer(routeLine);
    }

    // Приводим карту к границам маршрута
    if (points.length > 0) {
      let bounds = L.latLngBounds(points.map((p) => [p.lat, p.lon]));
      this.map.fitBounds(bounds, { padding: [20, 20] });
    }
  }

  // Метод для временной подсветки ячейки прямоугольником
  highlightCellTemporary(settings) {
    try {
      const {
        id,
        color = "#ffffff",
        opacity = 0.9,
        duration = 15000,
      } = settings;

      if (!id) {
        console.warn("Cannot highlight cell: ID is missing");
        return;
      }

      // Убираем предыдущую подсветку, если она есть
      this.clearHighlightRectangle();

      // Находим ячейку
      const match = this.match(id);
      if (!match || !match.scope) {
        console.warn("Cannot highlight cell: Cell not found for ID", id);
        return;
      }

      const cell =
        match.scope === "selectedCells"
          ? this.ChartsData.selectedCells[id].cell
          : this.ChartsData[match.scope][match.field][id].cell;

      if (!cell) {
        console.warn("Cannot highlight cell: Cell object not found for ID", id);
        return;
      }

      // Получаем границы ячейки
      const bounds = cell.getBounds();

      // Создаем прямоугольник подсветки
      this.currentHighlightRectangle = L.rectangle(bounds, {
        color: color,
        weight: 3,
        opacity: opacity,
        fillColor: color,
        fillOpacity: opacity * 0.3,
        stroke: true,
        dashArray: "10, 5", // Пунктирная линия для лучшей видимости
        interactive: false, // Прямоугольник не блокирует события мыши
      });

      // Добавляем прямоугольник на карту
      // this.currentHighlightRectangle.addTo(this.map)
      // this.currentHighlightRectangle.addTo(this.legsGroup)

      // Поднимаем прямоугольник наверх
      // this.currentHighlightRectangle.bringToFront()

      // Автоматически масштабируем карту к ячейке (область в 3 раза больше ячейки)
      this.zoomToCell(bounds, id);

      console.log(
        "Temporary highlight created for cell:",
        id,
        "with color:",
        color
      );

      // Автоматически убираем подсветку через указанное время
      // if (duration > 0) {
      //   setTimeout(() => {
      //     this.clearHighlightRectangle()
      //   }, duration)
      // }
    } catch (error) {
      console.error(
        "Error creating temporary highlight for cell:",
        settings.id,
        error
      );
    }
  }

  // Метод для масштабирования карты к ячейке с увеличенной областью просмотра
  zoomToCell(cellBounds, cellId = null) {
    try {
      // Получаем центр ячейки
      const center = cellBounds.getCenter();

      // Получаем размеры ячейки
      const cellWidth = Math.abs(cellBounds.getEast() - cellBounds.getWest());
      const cellHeight = Math.abs(
        cellBounds.getNorth() - cellBounds.getSouth()
      );

      // Увеличиваем область просмотра в 3 раза
      const expandedWidth = cellWidth * 3;
      const expandedHeight = cellHeight * 3;

      // Создаем расширенные границы
      const expandedBounds = L.latLngBounds([
        [center.lat - expandedHeight / 2, center.lng - expandedWidth / 2],
        [center.lat + expandedHeight / 2, center.lng + expandedWidth / 2],
      ]);

      // Масштабируем карту к расширенным границам с небольшим padding
      this.map.fitBounds(expandedBounds, {
        padding: [20, 20],
        maxZoom: 18, // Ограничиваем максимальный зум для удобства
      });

      console.log("Map zoomed to cell area:", expandedBounds.toString());

      // Показываем тултип в центре карты после зумирования
      // if (cellId) {
      //   setTimeout(() => {
      //     this.showCenterTooltip(center, cellId)
      //   }, 300) // Небольшая задержка для завершения анимации зума
      // }
    } catch (error) {
      console.warn("Error zooming to cell:", error);
    }
  }

  // Метод для показа тултипа в центре карты
  showCenterTooltip(center, cellId) {
    try {
      // Создаем временный маркер в центре для показа тултипа
      const centerMarker = L.marker(center, {
        opacity: 0, // Невидимый маркер
        keyboard: false,
        interactive: false,
      }).addTo(this.map);

      // Простое содержимое тултипа - только ID ячейки
      const tooltipContent = `<strong>${cellId}</strong>`;

      // Привязываем и открываем тултип
      centerMarker
        .bindTooltip(tooltipContent, {
          permanent: true,
          direction: "top",
          offset: L.point(0, -10),
          className: "center-cell-tooltip",
        })
        .openTooltip();

      // Убираем тултип через 5 секунд
      setTimeout(() => {
        if (centerMarker && this.map.hasLayer(centerMarker)) {
          this.map.removeLayer(centerMarker);
        }
      }, 3000);

      console.log("Center tooltip shown for cell:", cellId);
    } catch (error) {
      console.error("Error showing center tooltip:", error);
    }
  }

  // Метод для очистки текущего прямоугольника подсветки
  clearHighlightRectangle() {
    if (this.currentHighlightRectangle) {
      try {
        this.map.removeLayer(this.currentHighlightRectangle);
        this.currentHighlightRectangle = null;
        console.log("Temporary highlight rectangle cleared");
      } catch (error) {
        console.warn("Error clearing highlight rectangle:", error);
        this.currentHighlightRectangle = null;
      }
    }
  }

  // Метод для полной очистки карты и освобождения ресурсов
  destroy() {
    console.log("ChartsLeaf: начинаем уничтожение карты и очистку ресурсов");
    console.log("ChartsLeaf: текущие контролы перед удалением:", {
      searchButton: !!this.searchButton,
      graphButton: !!this.graphButton,
      multiTilesStateControl: !!this.multiTilesStateControl,
      coordInputControl: !!this.coordInputControl,
      upButton: !!this.upButton,
      downButton: !!this.downButton,
      cellButton: !!this.cellButton,
    });

    try {
      // Очищаем все слои
      this.clearCellslayer();
      this.clearSelectedCells();

      // Удаляем контролы
      if (this.layersControl) {
        this.layersControl.remove();
        this.layersControl = null;
      }

      if (this.customControl) {
        this.map.removeControl(this.customControl);
        this.customControl = null;
      }

      if (this.customControl1) {
        this.map.removeControl(this.customControl1);
        this.customControl1 = null;
      }

      // Удаляем EasyButton контролы
      if (this.searchButton) {
        this.map.removeControl(this.searchButton);
        this.searchButton = null;
      }

      if (this.graphButton) {
        this.map.removeControl(this.graphButton);
        this.graphButton = null;
      }

      if (this.upButton) {
        this.map.removeControl(this.upButton);
        this.upButton = null;
      }

      if (this.downButton) {
        this.map.removeControl(this.downButton);
        this.downButton = null;
      }

      // Удаляем контролы из базового класса
      if (this.multiTilesStateControl) {
        this.map.removeControl(this.multiTilesStateControl);
        this.multiTilesStateControl = null;
      }

      if (this.coordInputControl) {
        this.map.removeControl(this.coordInputControl);
        this.coordInputControl = null;
      }

      if (this.cellButton) {
        this.map.removeControl(this.cellButton);
        this.cellButton = null;
      }

      // Очищаем все слои данных
      if (this.ChartsLayers) {
        Object.keys(this.ChartsLayers).forEach((key) => {
          if (this.ChartsLayers[key]) {
            this.ChartsLayers[key].clearLayers();
            this.map.removeLayer(this.ChartsLayers[key]);
          }
        });
        this.ChartsLayers = null;
      }

      // Очищаем данные
      if (this.ChartsData) {
        Object.keys(this.ChartsData).forEach((key) => {
          if (this.ChartsData[key] && this.ChartsData[key].lg) {
            this.ChartsData[key].lg.clearLayers();
          }
        });
        this.ChartsData = null;
      }

      // Очищаем дополнительные группы слоев
      if (this.legsGroup) {
        this.legsGroup.clearLayers();
        this.map.removeLayer(this.legsGroup);
        this.legsGroup = null;
      }

      if (this.wpGroup) {
        this.wpGroup.clearLayers();
        this.map.removeLayer(this.wpGroup);
        this.wpGroup = null;
      }

      if (this.logbookGroup) {
        this.logbookGroup.clearLayers();
        this.map.removeLayer(this.logbookGroup);
        this.logbookGroup = null;
      }

      if (this.routeGroup) {
        this.routeGroup.clearLayers();
        this.map.removeLayer(this.routeGroup);
        this.routeGroup = null;
      }

      if (this.activePane) {
        this.activePane.clearLayers();
        this.map.removeLayer(this.activePane);
        this.activePane = null;
      }

      // Очищаем panes
      if (this.paneControl) {
        this.paneControl.clearPanes();
        this.paneControl = null;
      }

      // Удаляем карту
      if (this.map) {
        this.map.remove();
        this.map = null;
      }

      console.log("ChartsLeaf: все ресурсы очищены");
    } catch (error) {
      console.warn("ChartsLeaf: ошибка при очистке ресурсов", error);
    }
  }
}
